/// <reference path="../_references.js" />

if (isNullOrUndefined(veritracks.events)) {
    veritracks.events = {};
}

if (isNullOrUndefined(veritracks.events.mapping)) {
    veritracks.events.mapping = {};
}

var mEventsControls = new EventsControls(),
    mEventsData = new EventsData(),
    gEventLoadTimerId = 0,
    mDebugCounter = 0;
var lEventHistoryOffsetProperty= veritracks.system.clientSetting('EventHistoryOffset');
if(lEventHistoryOffsetProperty && !isNaN(Number(lEventHistoryOffsetProperty))){
    gSystemSettings.EventHistoryOffset = lEventHistoryOffsetProperty;
}
function resetContentHoldersEvents() {
    "use strict";
    if (!gUserDetails.RegionalOri) {
        $("#uEventsTab").removeClass("regionalOri");
    }
    var lMapContentHeight = $('#uEventsMapHolder').height(),
        lMapPlaybackHeight = $('#uMapPlaybackPanel').height(),
        lMapHolderHeight = lMapContentHeight - (lMapPlaybackHeight + 10),
        lTrackPointFilterHeight = $('#uTrackpointDetailCardViewFilterHolder').height(),
        lMapWidth = $('#uMapPanel').width(),
        lMapHeight = $('#uMapPanel').height(),
        lMapOffset = $('#uMapPanel').offset(),
        lNotificationWidth = $('#uMapNotificationPanel').width(),
        lLocateRight,
        lLocateBottom,
        lLocateRightAdjustment,
        lWindowWidth = $(window).width(),
        lWindowHeight = $(window).height(),
        lMapLegendHeight = lMapHolderHeight + lMapPlaybackHeight,
        lTrackPointCardViewHeight = lMapLegendHeight - lTrackPointFilterHeight;
    setWidth('#uNoMapData', lMapWidth);
    setHeight('#uNoMapData', lMapHeight);
    setHeight('#uMapLegendPanel', lMapHolderHeight + lMapPlaybackHeight);
    setHeight('#uTrackpointDetailCardViewHolder', lTrackPointCardViewHeight);


    if (!isNullOrUndefined(lMapOffset)) {
        lLocateRight = lWindowWidth - (lMapWidth + lMapOffset.left);
        lLocateBottom = lWindowHeight - (lMapHeight + lMapOffset.top);
        if (lLocateRight > 180 && lLocateBottom > 0) {
            $('#uLocateMapHolder').css('right', lLocateRight.toString() + 'px').css('bottom', lLocateBottom.toString() + 'px').show();
            $('#uMapNotificationPanel').css('bottom', lLocateBottom.toString() + 'px');
        } else {
            $('#uLocateMapHolder').hide();
        }
        $('#uMapNotificationPanel').css('margin-left', ((lMapWidth - lNotificationWidth) / 2).toString() + 'px');
        if (!$('#uMapDetailPanelCell').is(':visible')) {
            lLocateRightAdjustment = lLocateRight - 2;
            $('#uLocateMapHolder').css('right', lLocateRightAdjustment.toString() + 'px').css('bottom', lLocateBottom.toString() + 'px').show();
        }
    }

    setHeight('#uMapPanel', lMapHolderHeight);
    if (!isNullOrUndefined(mEventsControls.CardView)) {
        mEventsControls.CardView.resize();
    }
}

//------------
// Data Access
//------------

function getEvent(aId) {
    "use strict";
    var lResult = null,
        lObject = getDataItem(aId, 'Events');

    //if (typeof lObject !== 'undefined' && lObject !== null) {
    //    lResult = lObject;
    //}
    if (!isNullOrUndefined(lObject)) {
        lResult = lObject;
    }
    return lResult;
}

function getMetaEvent(aId) {
    "use strict";
    var lResult = null,
        lObject = getDataItem(aId, 'MetaEvents');
    //if (typeof lObject !== 'undefined' && lObject !== null) {
    //    lResult = lObject;
    //}
    if (!isNullOrUndefined(lObject)) {
        lResult = lObject;
    }
    return lResult;
}

function getMonitoredEvent(aEventId) {
    "use strict";
    var lResult = null,
        lObject = getDataItem(aEventId, 'MonitoredEvent');
    //if (typeof lObject !== 'undefined' && lObject !== null) {
    //    lResult = lObject;
    //}
    if (!isNullOrUndefined(lObject)) {
        lResult = lObject;
    }
    return lResult;
}

function formatEventEndDate(aJsonDate) {
    "use strict";
    var lDate = aJsonDate,
        lEpochDate = new Date(0),
        lMaxDate = new Date(3000, 1, 1),
        lReturn = '-In Progress-';
    //    if (typeof aJsonDate === 'string') {
    //        lDate = aJsonDate.WcfToDate();
    //    }
    if (lDate > lEpochDate && lDate < lMaxDate) {
        lReturn = DisplayShortDateTime(aJsonDate);
    }
    return lReturn;
}


function generateEventCards(aEventList) {
    "use strict";
    mDebugCounter++;
    var lBuilder = new SumoPredicateBuilder(),
        lEvents = aEventList,
        lEnrollees = getDataItems('Enrollees'),
        lAgents = getDataItems('Agents'),
        lUsers = getDataItems('Users'),
        lDevices = getDataItems('Devices'),
        lRiskLevels = getDataItems('RiskLevels'),
        lSort = new SortExpression(),
        lEnrollee = null,
        lEventDetails = [],
        lEventDetail,
        lTimezone,
        lEvent,
        lSortOrder = 0,
        lKey,
        //lAgentKey,
        //lEnrolleeKey,
        lMyAgents,
        lMyAgentIds = [],
        lEpoch = new Date(0),
        lEndDate,
        lDuration,
        lUser,
        lAssignments,
        lDebugCounter = 0;

    lBuilder.AddNewExpressionConditional('DisplayFlag', 1, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    lEvents = query(lEvents, lBuilder.RootExpression);
    lBuilder.Clear();

    lBuilder.AddNewExpressionConditional('UserId', gUserDetails.UserId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    lMyAgents = query(lAgents, lBuilder.RootExpression);
    lBuilder.Clear();
    for (lKey in lMyAgents) {
        if (lMyAgents.hasOwnProperty(lKey)) {
            lMyAgentIds.push(lMyAgents[lKey].Id);
        }
    }
    //defaultAlert('ged1');
    for (lKey in lEvents) {
        if (lEvents.hasOwnProperty(lKey)) {
            lDebugCounter++;
            //defaultAlert('ged1-1 - ' + mDebugCounter + '-' + lDebugCounter );
            lEvent = lEvents[lKey];
            lEventDetail = new EventsCard();
            lEventDetail.DataItem = lEvent;
            lEventDetail.OrganizationId = lEvent.OrganizationId;
            lEventDetail.EventId = lEvent.Id;
            lEventDetail.MetaEventId = lEvent.MetaEventId;
            lEventDetail.MetaEventDescription = formatterMetaEvent(lEvent.MetaEventId);//getMetaEvent(lEvent.MetaEventId).Description;
            lEventDetail.EnrolleeId = lEvent.EnrolleeId;
            lEnrollee = lEnrollees[lEvent.EnrolleeId];
            if (!isNullOrUndefined(lEnrollee)) {
                if (lEnrollee.InMyOrganization) {
                    lTimezone = getDataItem(lEnrollee.TimeZoneId, 'TimeZone');
                    lEventDetail.EnrolleeName = lEnrollee.FullName;
                    lEventDetail.EnrolleeFirstName = lEnrollee.FirstName;
                    lEventDetail.EnrolleeLastName = lEnrollee.LastName;
                    //defaultAlert('ged1-3 - ' + mDebugCounter + '-' + lDebugCounter);
                    lEventDetail.StartDateUTC = displayEventInEnrolleeTimeZone(lEvent.StartDateUTC, lEnrollee);
                    lEventDetail.StartDateDisplay = displayEnrolleeTimeZoneFormatted(lEvent.StartDateUTC, lTimezone);
                    lEventDetail.StopDateUTC = displayEventInEnrolleeTimeZone(lEvent.StopDateUTC, lEnrollee);
                    if (lEvent.IsOpen)
                        lEventDetail.StopDateDisplay = localizeWrapper('cEnrolleesMappingInProgress');
                    else
                        lEventDetail.StopDateDisplay = displayEnrolleeTimeZoneFormatted(lEvent.StopDateUTC, lTimezone);
                    lEventDetail.DeviceId = lEvent.DeviceId;
                    //defaultAlert('ged1-4 - ' + mDebugCounter + '-' + lDebugCounter);
                    if (lEvent.ZoneId !== -1) {
                        lEventDetail.ZoneName = lEvent.ZoneName;
                        if (isNullOrUndefined(lEventDetail.ZoneName) || lEventDetail.ZoneName == '')
                            lEventDetail.ZoneName = ZoneNameFormatter(lEvent.ZoneId);
                    }
                    //defaultAlert('ged1-5 - ' + mDebugCounter + '-' + lDebugCounter);
                    lEventDetail.ZoneTrackPointCount = lEvent.ZoneTrackPointCount;
                    if (!isNullOrUndefined(lDevices[lEvent.DeviceId])) {
                        lEventDetail.SerialNumber = lDevices[lEvent.DeviceId].SerialNumber;
                    }
                    //defaultAlert('ged1-6 - ' + mDebugCounter + '-' + lDebugCounter);
                    lEventDetail.IsOpen = lEvent.IsOpen;
                    lEventDetail.HasNotes = lEvent.HasNotes;
                    lEventDetail.HasNotesDisplay = displayBoolean(lEvent.HasNotes);
                    if (lEvent.IsConfirmed === true) {
                        lEventDetail.ConfirmedDateUTC = formatEventConfirmationDate(displayEventInEnrolleeTimeZone(lEvent.ConfirmedDateUTC, lEnrollee));
                    }
                    lEventDetail.IsConfirmed = lEvent.IsConfirmed;
                    lEventDetail.IsConfirmedDisplay = displayBoolean(lEvent.IsConfirmed);
                    lEventDetail.ConfirmedByUserId = lEvent.ConfirmedByUserId;
                    lUser = lUsers[lEvent.ConfirmedByUserId];
                    if (!isNullOrUndefined(lUser)) {
                        lEventDetail.ConfirmedByName = lUser.FullName;
                    }

                    //add item id if sobertrack for scheduleid
                    if (!isNullOrUndefined(lEvent.ItemId)) {
                        lEventDetail.ItemId = lEvent.ItemId;
                    }


                    if (lEvent.ConfirmedByUserId == 1) {
                        lEventDetail.ConfirmedByName = "System";
                    }
                    lEndDate = lEvent.StopDateUTC;
                    if (lEndDate <= lEpoch) {
                        lEndDate = new Date();
                    }
                    //defaultAlert('ged1-7 - ' + mDebugCounter + '-' + lDebugCounter);
                    lDuration = lEndDate - lEvent.StartDateUTC;
                    lEventDetail.Duration = Math.ceil(lDuration / (1000 * 60));

                    lSortOrder = 0;
                    lEventDetail.IsMyCaseload = (lMyAgentIds.indexOf(lEnrollee.AgentId) !== -1);

                    var lAgent = lAgents[lEnrollee.AgentId];
                    if (!isNullOrUndefined(lAgent))
                        lEventDetail.AgentofRecord = lAgent.FullName;
                    else
                        lEventDetail.AgentofRecord = 'Unknown';
                    //for (lAgentKey in lMyAgents) {
                    //    if (lEnrollee.AgentId === lMyAgents[lAgentKey].Id) {
                    //        lEventDetail.IsMyCaseload = true;
                    //        break;
                    //    }
                    //}
                    if (lEvent.IsOpen === true && lEvent.IsConfirmed === true) {
                        lSortOrder = 1;
                    } else if (lEvent.IsOpen === false && lEvent.IsConfirmed === false) {
                        lSortOrder = 2;
                    } else if (lEvent.IsOpen === false && lEvent.IsConfirmed === true) {
                        lSortOrder = 3;
                    }
                    //defaultAlert('ged1-8 - ' + mDebugCounter + '-' + lDebugCounter);
                    lAssignments = gCurrentDeviceAssignment[lEnrollee.Id];
                    lEventDetail.IsAssigned = (!isNullOrUndefined(lAssignments) && !isNullOrUndefined(lAssignments[lEvent.DeviceId]));
                    lEventDetail.HasMonitoredEvent = displayBoolean(lEvent.MonitoredEventId > -1);
                    lEventDetail.SortOrder = lSortOrder;
                    lEventDetail.SortId = (lEvent.IsOpen ? 2 : 1).toString() + lEventDetail.StartDateUTC.valueOf();

                    var lRiskLevel = lRiskLevels[lEvent.RiskLevelId + '.' + lEvent.OrganizationId + '.'];
                    lEventDetail.RiskLevel = lRiskLevel ? lRiskLevel.Name : ""
                    lEventDetail.RiskLevelId = lEvent.RiskLevelId
                    lEventDetails[lKey] = lEventDetail;
                }
            }
            //defaultAlert('ged1-9 - ' + mDebugCounter + '-' + lDebugCounter);
        }
    }
    lSort.addDescendingColumn('SortId');
    lEventDetails = lSort.sort(lEventDetails);
    //defaultAlert('ged2');
    return lEventDetails;
    //defaultAlert('gedfinal');
}

function generateEventData() {
    "use strict";
    var lEvents = getDataItems('Events'),
        lEventDetails = generateEventCards(lEvents),
        lSortState = getViewState('EventsCardViewSort');

    mEventsData.Clean = lEventDetails;
    mEventsData.Dirty = null;
    mEventsData.Sort = null;
    if (!isNullOrUndefined(lSortState)) {
        mEventsData.Sort = lSortState.Value.sort(mEventsData.Clean);
    }
}

function eventsDataItem_Updated(aCache, aData) {
    "use strict";
    var lCache = aCache,
        lData = aData;

    if (!isNullOrUndefined(mEventsControls.CardView)) {
        if (UpdateViewOnNewData(lData, mEnrolleesData.OffenderPaginated)) {
            generateEventData();
            mEventsControls.CardView.setUpdated(true);
        }
    }
}

function uEventsMapPlaybackStopButton_OnClick() {
    "use strict";

    if (!isNullOrUndefined(mEventsControls.PlaybackControl)) {
        mEventsControls.PlaybackControl.stop();
    }
    //mEventsData.PlaybackStatus = 'Stopped';
    mEventsData.PlaybackDirection = 1;
    mEventsData.PlaybackDivider = 1;
    //$('#uMapPlaybackProgressBar').width('0%');
    //$('#uEventsMapPlaybackPauseButton').hide();
    //$('#uEventsMapPlaybackStopCell').hide();
    //$('#uEventsMapPlaybackPlayButton').show();
    $('#uMapPlaybackStatus').html(localizeText('cEnrollee' + mEventsControls.PlaybackStatus));
    $('#uMapPlaybackSpeed').html('');
    $('#uMapPlaybackOutput').html('');
    $('#uSlider').slider('option', 'value', 0);
}


function uEventsShowConnectedTrackPoints_OnClick() {
    "use strict";
    mEventsControls.Map.layerShow('ConnectedTracks');
    mEventsControls.Map.layerShow('Labels');
    $('#uEventsShowConnectedButton').hide();
    $('#uEventsHideConnectedButton').show();
}

function uEventsHideConnectedTrackPoints_OnClick() {
    "use strict";
    mEventsControls.Map.layerHide('ConnectedTracks');
    mEventsControls.Map.layerHide('Labels');
    $('#uEventsShowConnectedButton').show();
    $('#uEventsHideConnectedButton').hide();
}

function populateEventsHeatMapData() {
    "use strict";
    var lCardList = [],
        lHeatDataSet = [];
    lCardList = lCardList.concat(mEventsControls.Map.layerGetDataSource('ConnectedTracks'));
    lCardList = lCardList.concat(mEventsControls.Map.layerGetDataSource('DistancePoints'));
    lCardList = lCardList.concat(mEventsControls.Map.layerGetDataSource('ConnectedDistancePoints'));

    for (var key in lCardList) {
        if (lCardList.hasOwnProperty(key)) {

            if (!isNullOrUndefined(lCardList[key]) && !isNullOrUndefined(lCardList[key].data)) {
                if (lCardList[key].data.hasOwnProperty("begin")) {
                    lHeatDataSet.push(lCardList[key].data.begin.data);

                    if (lCardList[key].data.hasOwnProperty("end")) {
                        lHeatDataSet.push(lCardList[key].data.end.data);
                    }

                    if (!isNullOrUndefined(lCardList[key].data.Latitude) && !isNullOrUndefined(lCardList[key].data.Longitude)) {
                        lHeatDataSet.push(lCardList[key].data);
                    }


                } else if (lCardList[key].data.hasOwnProperty("end")) {
                    lHeatDataSet.push(lCardList[key].data.end.data);
                    if (!isNullOrUndefined(lCardList[key].data.Latitude) && !isNullOrUndefined(lCardList[key].data.Longitude)) {
                        lHeatDataSet.push(lCardList[key].data);
                    }
                } else {
                    lHeatDataSet.push(lCardList[key].data);
                }
            }
        }
    }//end of for

    return lHeatDataSet;

}

function uShowHeatMap_OnClick() {
    "use strict";
    if (mEventsControls.Map.getHeatMap() == null) {
        var lHeatDataSet = populateEventsHeatMapData();
        mEventsControls.Map.layerHide('AllTrackpoints');
        mEventsControls.Map.setHeatMapDataPoints(lHeatDataSet);
        if (!isNullOrUndefined(mEventsControls.PlaybackControl)) {
            mEventsControls.PlaybackControl.Activate(false);
            uEventsMapPlaybackLock();
        }
    } else {
        var lFilterValues = mEventsControls.TrackpointCardViewFilter.Expression.Value;

        if (lFilterValues.indexOf("1") != -1) {
            mEventsControls.Map.layerShow('Adresses');
        }

        if (lFilterValues.indexOf("2") != -1) {
            mEventsControls.Map.layerShow('Zones');
        }

        if (lFilterValues.indexOf("5") != -1) {
            mEventsControls.Map.layerShow('AllTrackpoints');
        }

        if (!isNullOrUndefined(mEventsControls.PlaybackControl)) {
            mEventsControls.PlaybackControl.Activate(true);
            uEventsMapPlaybackLock();
        }
    }

    mEventsControls.Map.toggleHeatMap();

    if (mEventsControls.Map.getHeatMap() != null) {
        mEventsControls.Map.changeRadius(20);
        $("#uHeatMapButton").addClass("Selected");
    } else {
        $("#uHeatMapButton").removeClass("Selected");
    }
}

function EventDetailTrackpointHistory_OnLoad(aParams, aData, aAlcoholData) {
    "use strict";
    //var lMapSettingIds = mEventsControls.MapSettingsListView.selected();
    var lKey,
        lAKey,
        lItem,
        lTrackDetail,
        lEnrollee,
        lData = [],
        //lEvents = getDataItems('Events'),
        //lEvent,
        lEnrollees = getDataItems('Enrollees'),
        //lBuilder = new SumoPredicateBuilder(),
        lTrackItems = [],
        lTrackItem,
        lBuilder = new SumoPredicateBuilder(),
        lTotalPointCount = 0,
        lSortPredicate = new SortExpression(),
        //lCardList = [],
    //lZoneList = []
    lCardType;

    lSortPredicate.addAscendingColumn('TrackDate');

    if (aData.hasOwnProperty("Data")) {
        if (!isNullOrUndefined(aData.Data)) {
            lData = aData.Data;
            lData = lSortPredicate.sort(lData);
        }
    } else {
        lData = aData;
    }

    if (aParams === mEventsData.RequestId && !isNullOrUndefined(mEventsData.CurrentId)) {
        mActivityNotification.addNotification(localizeWrapper('cEnrolleeTrackpointsDisplayed') + ' ' + lData.length.toString());
        lTotalPointCount = lData.length.toString();

        $('#uEventsDetailTrackPointCount' + mEventsData.CurrentId).html(lTotalPointCount);
        //$('#uEventsDetailTrackPointCount').html(aData.length.toString());
        $('#uEventsDetailTrackPointCount' + aParams).html(lData.length.toString());
        if (lData.length > 0) {
            mEventsControls.PlaybackControl.Activate(true);

            FixDates(lData);

            $('#uEventsDetailTrackPointCount' + mEventsData.CurrentId.toString()).html(lData.length.toString());

            if (!isNullOrUndefined(aAlcoholData)) {
                for (lAKey in aAlcoholData) {
                    if (aAlcoholData.hasOwnProperty(lAKey)) {
                        mEventsData.CurrentTrackpoints.push(aAlcoholData[lAKey]);
                    }
                }

            }

            for (lKey in lData) {
                if (lData.hasOwnProperty(lKey)) {
                    lItem = lData[lKey];
                    switch (lItem.TrackTypeId) {
                        case 1:
                            lCardType = 5;
                            break;
                        case 2:
                            lCardType = 9;
                            break;
                        case 3:
                            lCardType = 8;
                            break;
                    }
                    lEnrollee = lEnrollees[lItem.EnrolleeId];
                    lTrackDetail = veritracks.enrollees.mapping.generateTrackpointCard(lItem, lCardType, lEnrollee, 1);
                    if (lTrackDetail)
                        mEventsData.CurrentTrackpoints.push(lTrackDetail);
                }
            }
        } else {
            mEventsControls.PlaybackControl.Activate(false);
        }



        uEventsMapPlaybackLock();
    }
    $('#uEventsTrackpointLoadingBar').hide();
    if (--mEventsData.MapRequestCount === 0) {
        mEventsControls.TrackpointCardViewFilter.filter();
    }
}

function uEventsMapPlaybackLock() {
    "use strict";

    if (!mEventsControls.PlaybackControl.IsActive()) {
        $('#uEventsMapPlaybackStopButtonDisabled').show();
        $('#uEventsMapPlaybackPreviousButtonDisabled').show();
        $('#uEventsMapPlaybackNextButtonDisabled').show();
        $('#uEventsMapPlaybackPlayButtonDisabled').show();
        $('#uEventsMapPlaybackFastForwardButtonDisabled').show();
        $('#uEventsMapPlaybackSlowDownButtonDisabled').show()
        $('#uEventsMapPlaybackFastForwardButtonDisabled').show();
        $('#uEventsMapPlaybackSlowDownButtonDisabled').show();
        $('#uEventsMapPlaybackStopButton').hide();
        $('#uEventsMapPlaybackPreviousButton').hide();
        $('#uEventsMapPlaybackNextButton').hide();
        $('#uEventsMapPlaybackPlayButton').hide();
        $('#uEventsMapPlaybackFastForwardButton').hide();
        $('#uEventsMapPlaybackSlowDownButton').hide()
        $('#uEventsMapPlaybackFastForwardButton').hide();
        $('#uEventsMapPlaybackSlowDownButton').hide();
        $('#uSlider').hide();
    } else {
        $('#uEventsMapPlaybackStopButtonDisabled').hide();
        $('#uEventsMapPlaybackPreviousButtonDisabled').hide();
        $('#uEventsMapPlaybackNextButtonDisabled').hide();
        $('#uEventsMapPlaybackPlayButtonDisabled').hide();
        $('#uEventsMapPlaybackFastForwardButtonDisabled').hide();
        $('#uEventsMapPlaybackSlowDownButtonDisabled').hide()
        $('#uEventsMapPlaybackFastForwardButtonDisabled').hide();
        $('#uEventsMapPlaybackSlowDownButtonDisabled').hide();
        $('#uEventsMapPlaybackStopButton').show();
        $('#uEventsMapPlaybackPreviousButton').show();
        $('#uEventsMapPlaybackNextButton').show();
        $('#uEventsMapPlaybackPlayButton').show();
        $('#uEventsMapPlaybackFastForwardButton').show();
        $('#uEventsMapPlaybackSlowDownButton').show()
        $('#uEventsMapPlaybackFastForwardButton').show();
        $('#uEventsMapPlaybackSlowDownButton').show();
        $('#uSlider').show();
    }
}

function eventNoteWrite_OnSuccess(aParams, aItem) {
    "use strict";

    function onRender(aSender, aParams, aData) {
        aSender.unbind('databind', onRender);
        aSender.selected(aData.Id);
    }

    FixDates(aItem);
    var lEvent = aParams;
    if (!isNullOrUndefined(lEvent)) {
        lEvent.HasNotes = true;
        setDataItem(aItem.EventId, 'Events', lEvent);
        WriteSingle(lEvent, null, null, {}, false);
        generateEventData();
        mEventsControls.CardView.bind('databind', onRender, lEvent);
        mEventsControls.CardViewFilter.filter();
    }
    mActivityNotification.addNotification(localizeWrapper('cEventNoteAdded'));
    mEventsControls.NotesManager.NotesList.push(aItem);
    mEventsControls.NotesManager.RenderContents();
    ClosePopup();
}

function eventNoteWrite_OnFailure(a, b, c) {
    "use strict";
    mActivityNotification.addNotification(localizeWrapper('cEnrolleeNoteNotSaved'));
}

function uEventsNotesManager_OnAdd(aNote) {
    "use strict";
    var lEvent = getDataItem(mEventsData.CurrentId, 'Events');
    WriteSingle(aNote, eventNoteWrite_OnSuccess, eventNoteWrite_OnFailure, lEvent);
}

function EventDetailEventNote_OnLoad(aParams, aData) {
    "use strict";

    if (aParams === mEventsData.RequestId) {
        FixDates(aData);
        mEventsControls.NotesManager = new SumoNotesManager('uEventsNotesManager', 'uEventsNotesHolder', aData, {
            'ClassName': 'Event',
            'OnAdd': uEventsNotesManager_OnAdd,
            'IdentificationProperty': 'EventId',
            'Identifier': mEventsData.CurrentId,
            'UserId': gUserDetails.UserId,
            'PermissionId': 32
        });
        mEventsControls.NotesManager.RenderContents();
    }
}

function EventDetailEventNote_OnFailure(aParams, aData) {
    "use strict";
}

function EventDetailTrackpointHistory_OnFailure(aParams, aData) {
    "use strict";
    //$('#uMapPanel').html(aData.responseText);
}

function eventsEnrolleeAddressList_OnSuccess(aParams, aData) {
    "use strict";
    var lList = [],
        lObject,
        i;
    for (i = 0; i < aData.length; i++) {
        lObject = aData[i];
        lList[lObject.Id] = lObject;
    }
    mCache.AddExpirableItem(lList, 'OffenderAddresses' + aParams.EnrolleeId.toString(), 300, true, null);
    if (aParams.Id === mEventsData.CurrentId) {
        veritracks.mapping.displayEnrolleeAddresses(lList, mEventsControls.Map, 'Addresses');
        //eventDisplayEnrolleeAddresses(lList);
    }
}

function eventDisplayEventZones(aZoneEventList) {
    "use strict";
    var lEnrolleeId,
        lZones = [],
        lZone,
        lItem,
        lKey;

    function zone_OnComplete(aParams, aData, aVertices) {
        var lCardList = [],
            lItem,
            lKey;

        for (lKey in aData) {
            if (aData.hasOwnProperty(lKey)) {
                lItem = aData[lKey];
                lCardList.push(veritracks.enrollees.mapping.generateZoneCard(lItem, aVertices[lItem.Id], aParams));
            }
        }

        mEventsData.CurrentTrackpoints = mEventsData.CurrentTrackpoints.concat(lCardList);
        if (--mEventsData.MapRequestCount === 0) {
            mEventsControls.TrackpointCardViewFilter.filter();
        }
    }

    for (lKey in aZoneEventList) {
        if (aZoneEventList.hasOwnProperty(lKey)) {
            lItem = aZoneEventList[lKey];
            lEnrolleeId = lItem.EnrolleeId;
            lZone = getDataItem(lItem.Id, 'Zones');
            if (!isNullOrUndefined(lZone)) {
                lZones.push(lZone);
            }
        }
    }
    veritracks.mapping.renderZones(mEventsControls.Map, 'Zones', lZones, zone_OnComplete, lEnrolleeId);






    //var lKey,
    //    lZone,
    //    lZoneEnrollee,
    //    lZoneList = [],
    //    //lItem,
    //    lZoneDetail,
    //    lTrackItem;

    //for (lKey in aZoneEventList) {
    //    if (aZoneEventList.hasOwnProperty(lKey)) {
    //        //lItem = aZoneEventList[lKey].data;
    //        lZoneEnrollee = aZoneEventList[lKey];
    //        lZone = getDataItem(lZoneEnrollee.Id, 'Zones');
    //        if (!isNullOrUndefined(lZone)) {
    //            lTrackItem = veritracks.mapping.prepareZoneItem(lZone);
    //            lZoneDetail = veritracks.enrollees.mapping.generateZoneCard(lTrackItem, lTrackItem.vertices, lZoneEnrollee.EnrolleeId);
    //            mEventsData.CurrentTrackpoints.push(lZoneDetail);
    //            lZoneList.push(lZoneDetail);
    //            //lTrackItem = veritracks.mapping.prepareZoneItem(lZone);
    //            //lZoneDetail = new MapCard();
    //            //lZoneDetail.Id = 'z' + lZone.Id;
    //            //lZoneDetail.Name = lZone.Name;
    //            //lZoneDetail.Type = lZone.Type;
    //            //lZoneDetail.TrackItem = lTrackItem;
    //            //lZoneDetail.Latitude = lZone.CenterLatitude;
    //            //lZoneDetail.Longitude = lZone.CenterLongitude;
    //            //lZoneDetail.SortOrder = 2;
    //            //lZoneDetail.Type = 2;
    //            //lZoneDetail.Address = '- no address available -';
    //            //lZoneDetail.IconClass = 'Zone';
    //            //lZoneDetail.Date = lZoneDetail.SortDate;
    //            //mEventsData.CurrentTrackpoints.push(lZoneDetail);
    //            //lZoneList.push(lZoneDetail);
    //        }
    //    }
    //}
    //mEventsControls.Map.layerSetDataSource('Zones', lZoneList);
    //mEventsControls.Map.layerSetDataSource('ZoneNames', veritracks.mapping.prepareEnrolleesZoneLabelOverlayData(lZoneList));
    //mEventsControls.TrackpointCardViewFilter.filter();
}

function eventsEventZoneList_OnSuccess(aParams, aData) {
    "use strict";
    var lList = [],
        lObject,
        i;
    for (i = 0; i < aData.length; i++) {
        lObject = aData[i];
        lList[lObject.Id] = lObject;
        //lList[lObject.ZoneId] = lObject;

    }
    mCache.AddExpirableItem(lList, 'EventZones' + aParams.Event.Id.toString(), 300, true, null);
    if (aParams.RequestId === mEventsData.RequestId) {
        eventDisplayEventZones(lList);
    }
}


function eventsMapPopulate_GetAddressesSuccess(aParams, aAddressList) {
    "use strict";
    var lCard = new MapCard(),
        lAddress,
        lEnrollee,
        lTrackItem,
        lKey;

    if (aParams.RequestId === mEventsData.RequestId) {
        for (lKey in aAddressList) {
            if (aAddressList.hasOwnProperty(lKey)) {
                lAddress = aAddressList[lKey];
                lEnrollee = getDataItem(lAddress.EnrolleeId, 'Enrollees');
                lCard = veritracks.enrollees.mapping.generateAddressCard(lAddress, lEnrollee, 1);
                if (lCard)
                    mEventsData.CurrentTrackpoints.push(lCard);
            }
        }
    }
    if (--mEventsData.MapRequestCount === 0) {
        mEventsControls.TrackpointCardViewFilter.filter();
    }
}

function eventsMapPopulate_GetAddresses(aEnrolleeId, aRequestId, aRequestCount, aEnrolleePosition) {
    "use strict";
    var lBuilder = new SumoPredicateBuilder();
    lBuilder.AddNewExpressionConditional('EnrolleeId', aEnrolleeId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    lBuilder.AddNewExpressionConditional('IsActive', true, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    ReadMultiple(gObjectList.EnrolleeAddress.AssemblyQualifiedName, lBuilder.RootExpression, 0, eventsMapPopulate_GetAddressesSuccess, Sad, { 'RequestId': aRequestId, 'RequestCount': aRequestCount, 'EnrolleePosition': 1 }, null, 20);
}

function CalculateAllEventsPlaybackTracksPoints() {
    "use strict";

    var lBuilder = new SumoPredicateBuilder(),
    lData = mEventsControls.TrackpointCardView.getDataSource(),
    lTotalTrackPointCount = 0;
    //trackpoints except address and zones
    lBuilder.AddNewExpressionConditional('SortOrder', 3, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    lBuilder.AddNewExpressionConditional('Type', 1, false, mRelationalOperatorEnum.IsNot(), mLogicalOperatorEnum.And());
    lBuilder.AddNewExpressionConditional('Type', 2, false, mRelationalOperatorEnum.IsNot(), mLogicalOperatorEnum.And());
    lData = query(lData, lBuilder.RootExpression);
    lTotalTrackPointCount = ObjectLength(lData);

    return lTotalTrackPointCount;
}
function uEventsTrackPointCardViewFilter_OnFilter(aSender, aExpression, aData) {
    "use strict";
    var lDataSet = [],
        lCardViewList = [],
        lTrackpointList = [],
        lAddressesList = [],
        lAlcoholPointList = [],
        lZonesList = [],
        lCardList = [],
        lIndexCounter = 0,
        lTrackItem,
        lCard,
        //lZoneList = [],
        lKey,
        lSort = new SortExpression(),
        lBuilder = new SumoPredicateBuilder(),
        lLabelList = [],
        lHasItems = (!isNullOrUndefined(mEventsData.CurrentTrackpoints) && mEventsData.CurrentTrackpoints.length > 0);

    $('#uTrackpointNoData').hide();
    mEventsControls.Map.layerSetDataSource('Selected', []);
    mEventsControls.Map.layerSetDataSource('AllTrackpoints', []);
    mEventsControls.Map.layerSetDataSource('Zones', []);
    mEventsControls.Map.layerSetDataSource('ZoneNames', []);
    mEventsControls.Map.layerSetDataSource('Addresses', []);
    mEventsControls.Map.layerSetDataSource('ConnectedTracks', []);
    mEventsControls.Map.layerSetDataSource('AlcoholTestPoints', []);
    mEventsControls.Map.layerSetDataSource('Labels', []);
    if (mEventsData.MapRequestCount === 0) {
        lDataSet = query(mEventsData.CurrentTrackpoints, aExpression);
        lSort.addAscendingColumn('SortOrder');
        lSort.addDescendingColumn('SortDate');
        lDataSet = lSort.sort(lDataSet);

        lIndexCounter = lDataSet.length;
        for (lKey in lDataSet) {
            if (lDataSet.hasOwnProperty(lKey)) {
                //lCard = $.extend({}, lDataSet[lKey]);
                lCard = lDataSet[lKey];
                if (!isNullOrUndefined(lCard)) {
                    lCard.DisplayName = lCard.Name + ' (' + lIndexCounter.toString() + ')';
                    lCardViewList.push(lCard);
                    lTrackItem = lCard.TrackItem;
                    if (!isNullOrUndefined(lTrackItem)) {
                        switch (lCard.SortOrder) {
                            case 1:
                                lAddressesList.push(lTrackItem);
                                break;
                            case 2:
                                //     if (lTrackItem.radius <= mEnrolleesData.MaximumZoneRadius) {
                                lZonesList.push(lTrackItem);
                                //    }
                                break;
                            case 3:
                                lTrackpointList.push(lTrackItem);
                                lCardList.push(lCard);
                                break;
                            case 4:
                                lAlcoholPointList.push(lTrackItem);
                                break;
                        }
                    }
                    --lIndexCounter;
                }
            }

        }
        lTrackpointList.reverse();
        lBuilder.AddNewExpressionConditional('Type', 2, false, mRelationalOperatorEnum.NotEqual(), mLogicalOperatorEnum.And());
        lLabelList = query(lCardViewList, lBuilder.RootExpression);

        mEventsControls.Map.layerSetDataSource('AllTrackpoints', lTrackpointList);
        mEventsControls.Map.layerSetDataSource('Zones', lZonesList);
        mEventsControls.Map.layerSetDataSource('ZoneNames', veritracks.mapping.prepareEnrolleesZoneLabelOverlayData(lZonesList));
        mEventsControls.Map.layerSetDataSource('Addresses', lAddressesList);
        mEventsControls.Map.layerSetDataSource('AlcoholTestPoints', lAlcoholPointList);
        mEventsControls.Map.layerSetDataSource('ConnectedTracks', veritracks.mapping.prepareTripPointLineSegmentData(lTrackpointList));
        mEventsControls.Map.layerSetDataSource('Labels', veritracks.mapping.prepareTrackpointDetailCardLabelOverlayData(lLabelList));
        mEventsControls.TrackpointCardView.setDataSource(lCardViewList);
        writeUserPreferences(aSender.FilterState);
        if (lDataSet.length > 0) {
            mEventsControls.Map.fitBounds();
        } else {
            if (lHasItems) {
                $('#uTrackpointNoData').text('No track data available for current filter.').show();
                // for filter
            } else {
                // no items
                $('#uTrackpointNoData').text('No track data available.').show();
            }
        }
    }

    if (CalculateAllEventsPlaybackTracksPoints() > 0) {
        mEventsControls.PlaybackControl.Activate(true);
        uEventsMapPlaybackLock();
    } else {
        mEventsControls.PlaybackControl.Activate(false);
        uEventsMapPlaybackLock();
    }

    if (!isNullOrUndefined(mEventsControls.Map.getHeatMap())) {
        mEventsControls.Map.disposeHeatMap();
        uShowHeatMap_OnClick();
    }
}

function eventsTrackPointCardViewFilter_Init() {
    "use strict";
    if (isNullOrUndefined(mEventsControls.TrackpointCardViewFilter)) {
        var lDoDisplayCellPoints = veritracks.system.clientSetting('MapDisplayCellCentroids'),
            lUserPreferences = getUserPreferences(12),
            lBuilder = new SumoPredicateBuilder(),
            lFilterSource = gMapFilterList,
            lFilterIds = ['1', '2', '5', '8', '9', '21', '31', '33'],
            lParams;

        if (lDoDisplayCellPoints) {
            lFilterIds.push(9);
        }

        lBuilder.AddNewExpressionConditional('Id', lFilterIds, false, mRelationalOperatorEnum.In(), mLogicalOperatorEnum.And());
        lFilterSource = query(lFilterSource, lBuilder.RootExpression);

        lParams = {
            'Title': localizeWrapper('cEnrolleeFindMapObjects'),
            'Content': '',
            'CssClass': 'DefaultFilter',
            'HideOnFilter': true,
            'OnFilter': uEventsTrackPointCardViewFilter_OnFilter,
            'Columns': [
                 //{ 'Id': 'Name', 'Title': 'Name', 'Type': 'Text', 'DataField': 'Name' },
                 { 'Id': 'Type', 'Title': localizeWrapper('cEnrolleeDisplay'), 'Type': 'CheckList', 'DataField': 'Type', 'DataSource': lFilterSource, 'DataTextField': 'Title', 'DataValueField': 'Id', 'DefaultValue': ['1', '2', '5', '8', '21'] }
            ],
            'Settings': null,
            'UserPreferences': lUserPreferences,
            'UserId': gUserDetails.UserId,
            'UserPreferenceType': 12
        };
        mEventsControls.TrackpointCardViewFilter = gFilterFactory.createControl('uTrackpointDetailCardViewFilter', 'uTrackpointDetailCardViewFilterHolder', lParams);
    } else {
        mEventsControls.TrackpointCardViewFilter.render();
    }
}

function uEventsTrackpointDetailCardViewNoAddressUpdate(aCard) {
    "use strict";
    aCard.Address = 'No Address Found';
    $('#uTrackpointAddress' + aCard.Id).text(aCard.Address);
}

function uEventsTrackpointDetailCardViewAddressUpdate(aCard, aAddressString, aAddress) {
    "use strict";

    function trackpoint_OnFailure(aParams, a, b, c) {
        var l = '';
    }

    function trackpoint_OnSuccess(aParams, aData) {
        var l = '';
    }

    function address_OnFailure(aParams, a, b, c) {
        var l = '';
    }

    function address_OnSuccess(aParams, aData) {
        aParams.AddressId = aData.Id;
        WriteSingle(aParams, trackpoint_OnSuccess, trackpoint_OnFailure, null, true);
    }

    function save(aAddress, lCard) {
        var lAddress = new Address(aAddress),
            lData = lCard.TrackItem.data;
        lAddress.AddressTypeId = 4;
        lAddress.Name = 'Trackpoint: ' + lData.Id + ' (street_address)';

        //WriteSingle(lAddress, address_OnSuccess, address_OnFailure, lData, true);
    }

    aCard.Address = aAddressString;
    $('#uTrackpointAddress' + aCard.Id).text(aCard.Address).attr('title', aCard.Address);
    $('#uTrackpointAddressDetail' + aCard.Id).text(aCard.Address).attr('title', aCard.Address);
    aCard.IsGeocoded = true;
    if (!isNullOrUndefined(aAddress)) {
        save(aAddress, aCard);
    }
}

function uEventsTrackpointDetailCardView_OnGeocode(aResult, aStatus) {
    "use strict";
    var lAddress,
        lCard;
    if (aStatus === 'OK') {
        lAddress = aResult;
        lCard = mEventsControls.TrackpointCardView.selectedDataItem();
        uEventsTrackpointDetailCardViewAddressUpdate(lCard, lAddress.formated_address, lAddress);
    } else {
        uEventsTrackpointDetailCardViewNoAddressUpdate(lCard);
    }
}

function eventsVisitAddressRead_OnSuccess(aParams, aData) {
    "use strict";
    var lAddress;
    if (aData.length > 0) {
        lAddress = aData[0];
        uEventsTrackpointDetailCardViewAddressUpdate(aParams.Card, lAddress.Description, null);
    } else {
        uEventsTrackpointDetailCardViewNoAddressUpdate(aParams.Card);
    }
}

function eventsVisitAddressRead_OnFailure(aParams, a, b, c) {
    "use strict";
    uTrackpointDetailCardViewNoAddressUpdate(aParams.Card);
}

function uEventsTrackpointDetailCardView_OnSelectChange(aSender, aCardIndex, aData) {
    "use strict";
    var lCard = aSender.selectedDataItem(),
        lTrackItem,
        lFilename;

    mEventsControls.Map.clearStreetView();

    if (!isNullOrUndefined(lCard)) {
        if ([5, 8, 9, 21, 31, 33].indexOf(lCard.Type) !== -1) {
            if (!lCard.IsGeocoded) {
                mEventsControls.Map.geocode(lCard.Latitude.toString() + ', ' + lCard.Longitude.toString(), uEventsTrackpointDetailCardView_OnGeocode);
            }

            if (lCard.Type == 21) {                
                uQuickReviewAlcoholMonitoring(lCard.TrackItem.data.Data);
                if (!lCard.IsGeocoded) {
                    mEventsControls.Map.geocode(lCard.Latitude.toString() + ', ' + lCard.Longitude.toString(), veritracks.enrollees.mapping.onGeocode, lCard);
                }
            }

            lTrackItem = $.extend({}, lCard.TrackItem);
            lFilename = lTrackItem.iconUri.substring(0, lTrackItem.iconUri.length - 4) + 'Selected.png';
            lTrackItem.iconUri = lFilename;
            mEventsControls.Map.layerSetDataSource('Selected', [lTrackItem]);
        } else {
            mEventsControls.Map.layerSetDataSource('Selected', []);
        }
        mEventsControls.Map.setCenter(lCard.Latitude, lCard.Longitude);
    }
}


function eventsTrackpointCardViewSort(aParams, aSort) {
    "use strict";
    var lEventTrackPoints = mEventsData.CurrentTrackpoints,
        lEventTrackPointsListSorted = [];

    lEventTrackPointsListSorted = aSort.sort(lEventTrackPoints);
    mEventsData.CurrentTrackpoints = lEventTrackPointsListSorted;
    mEventsControls.TrackpointCardViewFilter.filter();

}

function eventsTrackPointCardView_Init() {
    "use strict";
    mEventsControls.TrackpointCardView = new sumo.controls.CardView('uEventsTrackpointDetailCardView', 'uTrackpointDetailCardViewHolder',
        {
            'cardTemplate': 'Interface/Events.Map.Card.Template.htm',
            'selectMethod': 'single',
            'canUnselect': false,
            'cssClass': 'VeritracksCardView',
            'keyField': 'Id',
            'isSortable': false,
            'Columns': [
                {
                    'id': 'EnrolleeName',
                    'title': 'Enrollee Name'
                }]
        });
    mEventsControls.TrackpointCardView.bind('selectedchanged', uEventsTrackpointDetailCardView_OnSelectChange);
    mEventsControls.TrackpointCardView.bind('databind', cardView_OnDataBind);
    //mEventsControls.TrackpointCardView.bind('sort', eventsTrackpointCardViewSort);
}

function populateEventData(aEvent) {
    "use strict";

    if (mEventsData.PlaybackStatus !== 'Stopped') {
        uEventsMapPlaybackStopButton_OnClick();
    }
    mActivityNotification.addNotification(localizeWrapper('cEventGetMapData'));
    var lDoDisplayCellPoints = veritracks.system.clientSetting('MapDisplayCellCentroids'),
        //lEvent = getEvent(mEventsData.CurrentId),
        lBuilder = null,
        lStartDate = null,
        lEndDate = null,
        lNow = new Date(),
        lTrackpointType = null,
        lSortPredicate = null,
        //lMapSettings = mEventsControls.MapSettingsListView.selected(),
        //lAddressList = null,
        //lZoneList = null,
        lRequestId = gRequestManager.getRequestId(),
        lSpan = 0,
        lIsCapped = false,
        isTrackPointHistory = false,
        lEndDatePast;

    mEventsData.MapRequestCount = 0;

    if (!isNullOrUndefined(aEvent)) {
        mEventsData.MapRequestCount += 3;
        mEventsData.RequestId = lRequestId;
        mEventsData.CurrentTrackpoints = [];
        lBuilder = new SumoPredicateBuilder();
        lStartDate = new Date(aEvent.StartDateUTC.valueOf());
        var lHistoryTrackStartDate = veritracks.system.clientSetting('HistoryTrackStartDate');
        if (aEvent.StartDateUTC < lHistoryTrackStartDate) {
            isTrackPointHistory = true;
            lTrackpointType = gObjectList.TrackpointHistory.AssemblyQualifiedName;
        } else {
            lTrackpointType = gObjectList.Trackpoint.AssemblyQualifiedName;
        }
        lSortPredicate = new SortExpression();
        lSortPredicate.addAscendingColumn('TrackDate');

        if (aEvent.IsOpen) { // if event is inprogress. end date equals NOW
            lEndDate = new Date();
        } else {// otherwise end date equals end of the event ie event is closed
            lEndDate = new Date(aEvent.StopDateUTC.valueOf());
            lEndDate.addMinutes(20);
        }

        lEndDatePast = new Date(lEndDate.valueOf());
        lEndDatePast.addHours(-24); // end date past now is 24 hours before the end date

        if (lEndDatePast > lStartDate) {// which date is closer to NOW but still within a 24 hour time block
            lStartDate = lEndDatePast;
            lIsCapped = true;
        } else {
            lStartDate.addMinutes(-20);
        }

        lSpan = Math.ceil((lEndDate - lStartDate) / (1000 * 60 * 60));

        //Events
        if (lIsCapped) {
            mActivityNotification.addNotification('Event timeframe capped. Mapping last ' + lSpan + ' hours.'); //localize issue
        } else {
            mActivityNotification.addNotification('Mapping all points found for ' + lSpan + ' hour period starting at ' + DisplayShortDateTime(lStartDate));
        }

        eventsMapPopulate_GetAddresses(aEvent.EnrolleeId, lRequestId, null, 1);


        $('#uTrackpointNoData').hide();
        $('#uEventsTrackpointLoadingBar').show();

        var lEnrollee = getDataItem(aEvent.EnrolleeId, 'Enrollees');
        var ltTripStartDate = lStartDate;
        var ltTripEndDate = lEndDate;

        if (!isNullOrUndefined(aEvent.ItemId) && aEvent.ItemId != -1) { //rewrite this EE
            veritracks.mapping.readTripsVisits(aEvent.EnrolleeId, isTrackPointHistory, ltTripStartDate, ltTripEndDate, false, eventTripsAlcohol_OnSuccess, EventDetailTrackpointHistory_OnFailure, [lRequestId, aEvent.EnrolleeId, aEvent.ItemId, aEvent.StopDateUTC]);
        } else {
            veritracks.mapping.readTripsVisits(aEvent.EnrolleeId, isTrackPointHistory, ltTripStartDate, ltTripEndDate, false, eventTrips_onComplete, EventDetailTrackpointHistory_OnFailure, lRequestId);
        }


        lBuilder.Clear();
        lBuilder.AddNewExpressionConditional('EventId', mEventsData.CurrentId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
        ReadMultiple(gObjectList.EventNote.AssemblyQualifiedName, lBuilder.RootExpression, 0, EventDetailEventNote_OnLoad, EventDetailEventNote_OnFailure, lRequestId);

        lBuilder.Clear();
        lBuilder.AddNewExpressionConditional('EventId', aEvent.Id, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
        ReadMultiple(gObjectList.ZoneEvent.AssemblyQualifiedName, lBuilder.RootExpression, 0, eventsEventZoneList_OnSuccess, Sad, { 'RequestId': lRequestId, 'Event': aEvent }, null, 20);

        $('#uEventsEventCloseButton').hide();
        if (!aEvent.IsConfirmed) {
            $('#uIsConfirmedMessage').hide();
            $('#uConfirmEventButton').show();
            if (aEvent.IsOpen && aEvent.MetaEventId === 1003) {
                //$('#uEventsEventCloseButton').show();
                getEventMasterTamperCanCloseStatus([aEvent.Id], 'uEventsEventCloseButton');
            } else if (!aEvent.IsOpen && aEvent.MetaEventId === 1003) {
                $('#uEventsEventCloseButton').hide();
            }
        } else {
            $('#uIsConfirmedMessage').show();
            $('#uConfirmEventButton').hide();
            $('#uEventsEventCloseButton').hide();
        }
    } else {
        $('#uConfirmEventButton').hide();
        $('#uIsConfirmedMessage').hide();
    }
}

function alcoholTestItems_OnSuccess(aParams, aData) {
    "use strict";
    var ltrackDada = [];
    for (var i = 0; i <= aParams.length; i++) {
        mEventsData.CurrentTrackpoints.push(aParams[i]);
    }
}

function alcoholTestItems_OnFail(a, b, c) {
    "use strict";
    console.log(a, b, c);
}

function eventTripsAlcohol_OnSuccess(aParams, aData) {
    "use strict";
    var ltrackDada = [];
    var lData = aData.Groupings;
    for (var key in lData) {
        if (lData.hasOwnProperty(key)) {
            ltrackDada = ltrackDada.concat(lData[key].Trackpoints);
        }
    }

    veritracks.mapping.getAlchoholTestEvents(aParams[1], 1, aParams[2], aParams[3], EventDetailTrackpointHistory_OnLoad, alcoholTestItems_OnFail, [aParams[0], ltrackDada]);
}

function eventTrips_onComplete(aParams, aData) {
    "use strict";
    var ltrackDada = [];
    var lData = aData.Groupings;

    for (var key in lData) {
        if (lData.hasOwnProperty(key)) {
            ltrackDada = ltrackDada.concat(lData[key].Trackpoints);
        }
    }

    EventDetailTrackpointHistory_OnLoad(aParams, ltrackDada);
}

function eventsSetEmptyList() {
    "use strict";
    $('#uConfirmEventButton').hide();
    $('#uIsConfirmedMessage').hide();
    $('#uTrackpointNoData').text('No track data available.').show();
    mEventsData.CurrentTrackpoints = [];
    if (!isNullOrUndefined(mEventsControls.TrackpointCardViewFilter)) {
        mEventsControls.TrackpointCardViewFilter.filter();
    }
}

function uEventsCardView_OnSelectedChange(aSender, aSelectedKey, aData) {
    "use strict";

    if (mEventsData.PlaybackStatus !== 'Stopped') {
        uEventsMapPlaybackStopButton_OnClick();
    }

    function onTimer(aParams) {
        if (!isNullOrUndefined(mEventsControls.CardView)) {
            var lSelectedEvent = mEventsControls.CardView.selectedDataItem();
            //lEnrollees = getDataItems('Enrollees'),
            //lAgents = getDataItems('Agents'),
            //lEnrollee = null,
            //lAgent = null;
            //lEnrollee = lEnrollees[lSelectedEvent.EnrolleeId];
            //lAgent = lAgents[lEnrollee.AgentId];
            mEventsControls.NotificationPanel.clearNotifications();
            //lAgentId = getMyAgentIdsByOrganization(gUserDetails.UserId, lOrganizationId)[0];
            mEventsData.CurrentTrackpoints = [];
            mEventsControls.TrackpointCardView.setDataSource([]);
            mEventsControls.Map.layerSetDataSource('AllTrackpoints', veritracks.mapping.prepareTrackpointMarkerData([]));
            mEventsControls.Map.layerSetDataSource('Zones', []);
            veritracks.security.controller.extendSession();
            mEventsData.CurrentId = aParams;

            if (!isNullOrUndefined(lSelectedEvent)) {
                mEventsData.MapRenderState = new MapSettingState();
                populateEventData(lSelectedEvent.DataItem);
                $('#uHeaderEventsDetailConfirmedByUserId').html(lSelectedEvent.ConfirmedByName);
                $('#uHeaderEventsDetailConfirmedDateUTC').html(lSelectedEvent.ConfirmedDateUTC);
                if (lSelectedEvent.DataItem.MonitoredEventId !== -1) {
                    $('#uMonitoredEventInstantReport').show();
                }
                else {
                    $('#uMonitoredEventInstantReport').hide();
                }
                setViewState('EventsSelectedEvent', lSelectedEvent.EventId);
            } else {
                $('#uMonitoredEventInstantReport').hide();
                eventsSetEmptyList();
            }
        }
    }

    mEventsControls.CardViewTimer.SetTimer(onTimer, aSelectedKey);
}

function uMonitoredEventInstantReport_OnClick() {
    var lSelectedEvent = mEventsControls.CardView.selectedDataItem();
    var lAgentId = getMyAgentIdsByOrganization(gUserDetails.UserId, [lSelectedEvent.DataItem.OrganizationId])[0];
    CreateMonitoredInstantReport(lSelectedEvent.DataItem.MonitoredEventId, lAgentId);
}

function uEventsCardViewSortOnViewState() {
    "use strict";
    var lSortState = getViewState('EventsCardViewSort');
    if (!isNullOrUndefined(lSortState)) {
        mEventsControls.CardView.sortExpression(lSortState.Value);
    }
}

function uEventsCardView_OnUpdate() {
    "use strict";
    mEventsControls.CardViewFilter.filter();
    uEventsCardViewSortOnViewState();
}

function uEventsCardView_OnDataBind(aSender, aParams, aData) {
    "use strict";
    mEventsControls.CardView.unbind('databind', uEventsCardView_OnDataBind);
    mEventsControls.CardView.bind('databind', cardView_OnDataBind);
    mEventsControls.CardView.selected(aData);
}

function eventsSearch_OnDataBind(aSender, aParams, aData) {
    "use strict";
    mEventsControls.CardView.unbind('databind', eventsSearch_OnDataBind);
    mEventsControls.CardView.selectedIndex(0);
}

function uEventsCardView_OnSort(aParams, aSort) {
    "use strict";
    var lEvents = mEventsData.Clean,
        lEventsSortedList = [];

    lEventsSortedList = aSort.sort(lEvents);
    mEventsData.Sort = lEventsSortedList;
    setViewState('EventsCardViewSort', aSort);
    mEventsData.IsSort = true;
    mEventsControls.CardViewFilter.filter();
}

function uEventsCardView_Init(aSender, aEvent, aData) {
    "use strict";
    var lViewState = getViewState('EventsSelectedEvent');
    var lEnrolleesViewEvents = getViewState('EnrolleesViewEvents');
    mEventsControls.CardView = new sumo.controls.CardView('uEventsCardView', 'uEventsListHolder', {
        'cardTemplate': 'Interface/Events.Card.Template.htm',
        'selectMethod': 'single',
        'canUnselect': false,
        'keyField': 'EventId',
        'keyFieldType': 'number',
        'cssClass': 'VeritracksCardView',
        'isSortable': true,
        'Columns': [
            { 'id': 'EnrolleeFirstName', 'title': localizeWrapper('cEnrolleeFirstName') },
            { 'id': 'EnrolleeLastName', 'title': localizeWrapper('cEnrolleeLastName') },
            { 'id': 'StartDateUTC', 'title': localizeWrapper('cEnrolleeStartDate') },
            { 'id': 'StopDateUTC', 'title': localizeWrapper('cEnrolleeStopDate') },
            { 'id': 'IsOpen', 'title': localizeWrapper('cEventOpenClosed') },
            { 'id': 'IsConfirmed', 'title': localizeWrapper('cEventConfirmed') }
        ]
    });
    mEventsControls.CardView.bind('selectedchanged', uEventsCardView_OnSelectedChange);
    //mEventsControls.CardView.bind('render', cardView_OnDataBind);
    mEventsControls.CardView.bind('update', uEventsCardView_OnUpdate);
    mEventsControls.CardView.bind('sort', uEventsCardView_OnSort);
    if (!isNullOrUndefined(lViewState) && isNullOrUndefined(lEnrolleesViewEvents)) {
        mEventsControls.CardView.bind('databind', uEventsCardView_OnDataBind, lViewState.Value);
    } else {
        mEventsControls.CardView.bind('databind', cardView_OnDataBind);
    }
}

function uEventsPaginator_OnPageChanged(aSender, aNewPage, aData) {
    "use strict";
    if (!isNullOrUndefined(mEventsData.HistoryDirty)) {
        mEventsData.HistoryPaginated = aSender.paginate(mEventsData.HistoryDirty);
        mEventsControls.CardView.setDataSource(mEventsData.HistoryPaginated);
    } else if (!isNullOrUndefined(mEventsData.Dirty)) {
        mEventsData.Paginated = aSender.paginate(mEventsData.Dirty);
        mEventsControls.CardView.setDataSource(mEventsData.Paginated);
    }
    setViewState('EventsSelectedPage', aNewPage);
}

function gPaginatorFactory_OnEventsInit() {
    "use strict";
    var lEventState = getViewState('EventsSelectedEvent'),
        lPageState = getViewState('EventsSelectedPage');

    mEventsControls.CardViewPaginator = new sumo.controls.Paginator('uEventsPaginator', 'uEventsPagerHolder', {
        'ItemCount': count(mEventsData.Dirty),
        'ItemsPerPage': gPaginationSettings.EventsItems
    });
    if (!isNullOrUndefined(lEventState) && !isNullOrUndefined(lPageState)) {
        mEventsControls.CardViewPaginator.setPage(lPageState.Value);
    }
    mEventsControls.CardViewPaginator.bind('pagechanged', uEventsPaginator_OnPageChanged);
}

function uEventsCardViewFilter_OnFilter(aSender, aExpression, aData) {
    "use strict";
    var lData,
        lSort = new SortExpression(),
        lBuilder,
        lIsEmpty,
        lDoHistorySearch = false,
        lHistoryExpression,
        lStartDateFilter = evaluateExpressionValue(aExpression, 'StartDateUTC'),
        lEndDateFilter = evaluateExpressionValue(aExpression, 'StopDateUTC'),
        lSortState = getViewState('EventsCardViewSort'),
        lRiskLevelFilterIds = getRiskLevelFilter(aExpression),
        lEventCacheStartDate = new Date(),
        lStartDate,
        lEndDate;

    uFilterEventEventsCleaner();
    aExpression = mEventsControls.CardViewFilter.Expression;

    aExpression = removeExpressionValue(aExpression, ['RiskLevel'])

    function populateCardView(aEventList) {
        if (isNullOrUndefined(mEventsControls.CardViewPaginator)) {
            gPaginatorFactory_OnEventsInit();
        }
        lIsEmpty = (aEventList.length === 0);
        veritracks.system.applyFilterState('Events', lIsEmpty);
        if (isNullOrUndefined(lSortState)) {
            // aEventList = EventsSortFormatter(aEventList);
        }
        aEventList = mEventsControls.CardViewPaginator.paginate(aEventList);
        mEventsControls.CardView.setDataSource(aEventList);
        if (lIsEmpty) {
            eventsSetEmptyList();
        }
    }


    function history_OnSuccess(aParams, aData) {
        FixDates(aData);
        var lEventDetails = generateEventCards(aData);

        if (!isNullOrUndefined(aExpression)) {
            lEventDetails = query(lEventDetails, aExpression);
        }
        mEventsData.HistoryClean = lEventDetails;
        mEventsData.HistoryDirty = lEventDetails;
        if (!isNullOrUndefined(lSortState)) {
            mEventsData.HistorySort = lSortState.Value.sort(mEventsData.HistoryClean);
            lEventDetails = mEventsData.HistorySort;
        }

        function onToggleOff() {
            populateCardView(lEventDetails);
        }
        setLoadingBarStatus('uEventsCardViewLoadingBar', 'uEventsListHolder', false, onToggleOff);
    }

    function history_OnFailure(aParams, a, b, c) {
        var l = '';
    }



    if (!mEventsData.IsSort) {
        mEventsData.HistoryClean = null;
        mEventsData.HistoryDirty = null;
        mEventsData.HistorySort = null;
        mEventsData.HistoryPaginated = null;
    }
    mEventsData.IsSort = false;

    if (isNullOrUndefined(mEventsData.Sort)) {
        lData = mEventsData.Clean;
        //lSort.addAscendingColumn('SortOrder');
        lSort.addDescendingColumn('SortId');
        lData = lSort.sort(lData);
        mEventsData.Sort = lData;
    }
    var lEventHistoryOffsetProperty= veritracks.system.clientSetting('EventHistoryOffset');
    if(lEventHistoryOffsetProperty && !isNaN(Number(lEventHistoryOffsetProperty))){
        gSystemSettings.EventHistoryOffset = lEventHistoryOffsetProperty;
    }
    lEventCacheStartDate.addDays(-gSystemSettings.EventHistoryOffset);
    if (lStartDateFilter.length > 0) {
        lStartDate = lStartDateFilter[0].Value;
        lDoHistorySearch = lStartDate <= lEventCacheStartDate;
    }
    if (!lDoHistorySearch && lEndDateFilter.length > 0) {
        lEndDate = lEndDateFilter[0].Value;
        lDoHistorySearch = lEndDate <= lEventCacheStartDate;
    }


    function onToggle(aBuilder) {
        if (!isNullOrUndefined(mEventsControls.CardViewPaginator)) {
            mEventsControls.CardViewPaginator.paginate([]);
        }
        ReadMultiple(gObjectList.EventHistory.AssemblyQualifiedName, aBuilder.RootExpression, 0, history_OnSuccess, history_OnFailure, null, null, 0, true);
    }

    if (mEventsData.TargetId !== -1) {
        lBuilder = new SumoPredicateBuilder();
        lBuilder.AddNewExpressionConditional('EventId', mEventsData.TargetId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
        lData = query(mEventsData.Sort, lBuilder.RootExpression);
        mEventsControls.CardView.bind('databind', eventsSearch_OnDataBind);
        if (lData.length > 0) {
            mEventsData.Dirty = lData;
            populateCardView(lData);
        } else {
            aExpression = null;
            lBuilder.Clear();
            lBuilder.AddNewExpressionConditional('Id', mEventsData.TargetId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
            setLoadingBarStatus('uEventsCardViewLoadingBar', 'uEventsListHolder', true, function () { onToggle(lBuilder); });
        }
        mEventsData.TargetId = -1;
    } else {
        if (lDoHistorySearch) {
            lData = [];
            if (isNullOrUndefined(mEventsData.HistoryClean)) {
                mEventsControls.CardView.setDataSource(lData);
                lHistoryExpression = removeExpressionValue(aExpression, ['EnrolleeName', 'IsMyCaseload', 'IsAssigned', 'Duration', 'AgentofRecord']);
                lBuilder = new SumoPredicateBuilder();
                if (lHistoryExpression.__type === 'ExpressionBinary:www.sumosoftware.com/Expressions') {
                    lBuilder.AddExpressionBinary(lHistoryExpression);
                } else {
                    lBuilder.AddConditional(lHistoryExpression);
                }
                if (lEndDateFilter.length > 0)
                    lBuilder.AddNewExpressionConditional('StartDateUTC', lEndDateFilter[0].Value, false, mRelationalOperatorEnum.LessThanOrEqual(), mLogicalOperatorEnum.And());
                var lMyEnrolleeIds,
                    kBuilder = new SumoPredicateBuilder(),
                    lEnrollees;

                if (lRiskLevelFilterIds) {
                    var lOrganizationIds = getOrganizationsForRiskLevels(lRiskLevelFilterIds)
                    lBuilder.AddNewExpressionConditional('OrganizationId', lOrganizationIds, false, mRelationalOperatorEnum.In(), mLogicalOperatorEnum.And());
                    lBuilder.AddNewExpressionConditional('RiskLevelId', lRiskLevelFilterIds, false, mRelationalOperatorEnum.In(), mLogicalOperatorEnum.And());
                }

                kBuilder.AddNewExpressionConditional("InMyOrganization", true, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
                lEnrollees = query(getDataItems('Enrollees'), kBuilder.RootExpression);
                lMyEnrolleeIds = getArrayByIds(lEnrollees);
                lBuilder.AddNewExpressionConditional('EnrolleeId', lMyEnrolleeIds, false, mRelationalOperatorEnum.In(), mLogicalOperatorEnum.And());
                setLoadingBarStatus('uEventsCardViewLoadingBar', 'uEventsListHolder', true, function () { onToggle(lBuilder); });
            } else {
                if (!isNullOrUndefined(lSortState)) {
                    mEventsData.HistorySort = lSortState.Value.sort(mEventsData.HistoryClean);
                    populateCardView(mEventsData.HistorySort);
                } else {
                    populateCardView(mEventsData.HistoryClean);
                }
            }
        } else {
            if (mEventsData.TargetId === -1) {
                lBuilder = new SumoPredicateBuilder();
                if (aExpression.__type === 'ExpressionBinary:www.sumosoftware.com/Expressions') {
                    lBuilder.AddExpressionBinary(aExpression);
                } else {
                    lBuilder.AddConditional(aExpression);
                }
                if (lEndDateFilter.length > 0)
                    lBuilder.AddNewExpressionConditional('StartDateUTC', lEndDateFilter[0].Value, false, mRelationalOperatorEnum.LessThanOrEqual(), mLogicalOperatorEnum.And());


                if (lRiskLevelFilterIds) {
                    var lOrganizationIds = getOrganizationsForRiskLevels(lRiskLevelFilterIds)
                    lBuilder.AddNewExpressionConditional('OrganizationId', lOrganizationIds, false, mRelationalOperatorEnum.In(), mLogicalOperatorEnum.And());
                    lBuilder.AddNewExpressionConditional('RiskLevelId', lRiskLevelFilterIds, false, mRelationalOperatorEnum.In(), mLogicalOperatorEnum.And());
                }
                lData = query(mEventsData.Sort, lBuilder.RootExpression);
            }
            mEventsData.Dirty = lData;
            populateCardView(lData);
        }
    }

}

function getRiskLevelFilter(aExpression) {
    var lRiskLevelFilter = evaluateExpressionValue(aExpression, 'RiskLevel')[0];

    if (lRiskLevelFilter) {
        var lIds = lRiskLevelFilter.Value.split(",").map(Number).unique();

        if (lIds.length > 1) {

        } else {
            return lIds
        }
    }

}

function getOrganizationsForRiskLevels(aRiskLevelIds) {
    return Object.values(getDataItems('RiskLevels')).filter(function (a) {
        if (aRiskLevelIds.indexOf(a.Id) !== -1) {
            return a
        }
    }).map(function(b){return b.OrganizationId})
}

function getEventsFilterMetaEvents() {
    "use strict";
    var //lMetricTypes = getDataItems('MetricType'),
        lEventGroups = getDataItems('EventGroup'),
        lMetricMetaEvents = getDataItems('MetricMetaEvent'),
        lSort = new SortExpression(),
        //lMetricMetaEvent = null,
        lGroupLists = {},
        lResult = {},
        lItem,
        lKey;

    for (lKey in lMetricMetaEvents) {
        if (lMetricMetaEvents.hasOwnProperty(lKey)) {
            lItem = lMetricMetaEvents[lKey];
            if (isNullOrUndefined(lGroupLists[lItem.Id])) {
                lGroupLists[lItem.Id] = [];
            }
            lGroupLists[lItem.Id].push(lItem.MetaEventId);
        }
    }
    for (lKey in lEventGroups) {
        if (lEventGroups.hasOwnProperty(lKey)) {
            lItem = lEventGroups[lKey];
            if (!isNullOrUndefined(lGroupLists[lItem.Id]) && lGroupLists[lItem.Id].length > 0) {
                lResult[lItem.Id] = { 'Id': lItem.Id, 'Description': dataItemFormatter('EventGroup', 'Description', '', lItem.Id), 'data': lGroupLists[lItem.Id] };
            }
        }
    }

    lSort.addAscendingColumn('Description');
    lResult = lSort.sort(lResult);
    return lResult;
}

function getGroupMetaEvents(aGroupId) {
    var lBuilder = new SumoPredicateBuilder(),
        lResults = [],
        lMetricMetaEvents = getDataItems('MetricMetaEvent');


    lBuilder.AddNewExpressionConditional('Id', aGroupId, false, mRelationalOperatorEnum.In(), mLogicalOperatorEnum.And());
    lResults = query(lMetricMetaEvents, lBuilder.RootExpression);
    return lResults;
}

function getMetaEventIds(aMetaEvents) {
    var lResults = [];
    for (var lKey in aMetaEvents) {
        if (aMetaEvents.hasOwnProperty(lKey)) {
            lResults.push(aMetaEvents[lKey].MetaEventId);
        }
    }

    return lResults;
}

function uEventsReturnEnrolleeButton_OnClick() {
    var lLocations = getViewState('EnrolleesViewEventsLocation');
    deleteViewState('EnrolleesViewEventsLocation');
    if (!isNullOrUndefined(mEventsControls.CardView)) {
        mEventsControls.CardView = null;
    }
    window.location.hash = 'Enrollees.Offenders.' + lLocations.Value + '.Events.' + mEventsData.ReturnEnrolleeId.toString();
}

function gFilterFactory_OnEventsInit(aSender, aEvent, aData) {
    "use strict";
    var lUserPreferences = getUserPreferences(11),
        lEnrolleesViewEvents = getViewState('EnrolleesViewEvents'),
        lTimeRanges = [
            { 'Value': -1, 'Text': '' },
            { 'Value': 60, 'Text': localizeText('cOneHour') },
            { 'Value': 180, 'Text': localizeText('cThreeHour') },
            { 'Value': 360, 'Text': localizeText('cSixHour') },
            { 'Value': 720, 'Text': localizeText('cTwelveHour') },
            { 'Value': 1440, 'Text': localizeText('cOneDay') },
            { 'Value': 10080, 'Text': localizeText('cOneWeek') }
        ],
        lOrganizations = getDataItems('Organizations'),
        lIsConfirmable = false,
        //lEventState = '',
        lParams,
        lItem,
        lKey;



    for (lKey in lOrganizations) {
        if (lOrganizations.hasOwnProperty(lKey)) {
            lItem = lOrganizations[lKey];
            lIsConfirmable = (lItem.EventActionType === 2);
            if (lIsConfirmable) {
                break;
            }
        }
    }

    // dont want any other filters to get in the way so remove them and bring in only name.
    if (!isNullOrUndefined(lEnrolleesViewEvents)) {
        lUserPreferences = {};
        var lEnrollee = getDataItem(lEnrolleesViewEvents.Value, 'Enrollees');
        lUserPreferences.EnrolleeName = new UserPreference();
        lUserPreferences.EnrolleeName.Value = lEnrollee.FullName;
        deleteViewState('EnrolleesViewEvents');
        $('#uEventsReturnEnrolleeButton').show();
        $('#uEventsReturnEnrolleeButton').text(lEnrollee.FullName);
        mEventsData.ReturnEnrolleeId = lEnrollee.Id;
    } else {
        $('#uEventsReturnEnrolleeButton').hide();
    }

    var lRiskLevels = [];
    Object.values(getDataItems('RiskLevels')).forEach(function (level) {
        if (!lRiskLevels[level.Name]) {
            lRiskLevels[level.Name] = {
                OrganizationList: [],
                Name: level.Name,
                Id: []
            }
        }
        lRiskLevels[level.Name].OrganizationList.push(level.OrganizationId)
        lRiskLevels[level.Name].Id.push(level.Id)
    })

    lParams = {
        'Title': localizeWrapper('cEventFindEvents'),
        'Content': '',
        'CssClass': 'DefaultFilter',
        'HideOnFilter': true,
        'OnFilter': uEventsCardViewFilter_OnFilter,
        'Columns': [
                { 'Id': 'AllActionableEvent', 'Title': localizeWrapper('cEventAllActionableEvents'), 'DataTextField': 'Description', 'DataValueField': 'Id', 'Type': 'CheckList', 'DataSource': [{ 'Id': 'SelectAll', 'Description': localizeText('cSelectAll'), 'data': true }] },
                { 'Id': 'EventType', 'Title': localizeWrapper('cEventType'), 'Type': 'CheckList', 'Class': 'EventsFilterTypeList', 'DataField': 'MetaEventId', 'DataSource': getEventsFilterMetaEvents(), 'DataTextField': 'Description', 'DataValueField': 'Id' },
                { 'Id': 'EnrolleeName', 'Title': localizeWrapper('cEnrollee'), 'Type': 'Text', 'DataField': 'EnrolleeName' },
		{ 'Id': 'AgentofRecord', 'Title': localizeWrapper('cEventAgentOfRecord'), 'Type': 'Text', 'DataField': 'AgentofRecord' },
                { 'Id': 'IsOpen', 'Title': localizeWrapper('cEventIsOpen'), 'Type': 'Dropdown', 'DataField': 'IsOpen', 'DataSource': [{ 'Value': true, 'Text': localizeText('cYes') }, { 'Value': false, 'Text': localizeText('cNo') }], 'DataValueField': 'Value', 'DataTextField': 'Text', 'DefaultValue': '', 'ComparisonType': 'Boolean', 'InsertBlank': true, 'BlankText': localizeText('cBoth') },
                { 'Id': 'IsConfirmed', 'Title': localizeWrapper('cEventIsConfirmed'), 'Type': 'Dropdown', 'DataField': 'IsConfirmed', 'DataSource': [{ 'Value': true, 'Text': localizeText('cYes') }, { 'Value': false, 'Text': localizeText('cNo') }], 'DataValueField': 'Value', 'DataTextField': 'Text', 'DefaultValue': '', 'ComparisonType': 'Boolean', 'InsertBlank': true, 'BlankText': localizeText('cBoth') },
                /*Artifact artf71366: Events Tile adding capability to allow filter events that have been confirmed but no notes*/
                 { 'Id': 'HasNotes', 'Title': localizeWrapper('cEventHasNotes'), 'Type': 'Dropdown', 'DataField': 'HasNotes', 'DataSource': [{ 'Value': true, 'Text': localizeText('cYes') }, { 'Value': false, 'Text': localizeText('cNo') }], 'DataValueField': 'Value', 'DataTextField': 'Text', 'DefaultValue': '', 'ComparisonType': 'Boolean', 'InsertBlank': true, 'BlankText': localizeText('cBoth') },
                { 'Id': 'IsMyCaseload', 'Title': localizeWrapper('cEnrolleeMyCaseload'), 'Type': 'Dropdown', 'DataField': 'IsMyCaseload', 'DataSource': [{ 'Value': true, 'Text': localizeText('cYes') }, { 'Value': false, 'Text': localizeText('cNo') }], 'DataValueField': 'Value', 'DataTextField': 'Text', 'DefaultValue': '', 'ComparisonType': 'Boolean', 'InsertBlank': true, 'BlankText': localizeText('cBoth') },
                { 'Id': 'IsAssigned', 'Title': localizeWrapper('cEnrolleeActivelyAssigned'), 'Type': 'Dropdown', 'DataField': 'IsAssigned', 'DataSource': [{ 'Value': true, 'Text': localizeText('cYes') }, { 'Value': false, 'Text': localizeText('cNo') }], 'DataValueField': 'Value', 'DataTextField': 'Text', 'DefaultValue': '', 'ComparisonType': 'Boolean', 'InsertBlank': true, 'BlankText': localizeText('cBoth') },
                { 'Id': 'RiskLevelId', 'Title': localizeWrapper('cEnrolleeRiskLevel'), 'Type': 'Dropdown', 'DataField': 'RiskLevel',  'DataSource': lRiskLevels, 'DataValueField': 'Id', 'DataTextField': 'Name', 'InsertBlank': true, 'BlankText': localizeText('cAll') },
                { 'Id': 'StartDateUTC', 'Title': localizeWrapper('cAnalysisStart'), 'Type': 'Date', 'DataField': 'StartDateUTC', 'DefaultValue': '', 'relationalOperatorxx': mRelationalOperatorEnum.LessThanOrEqual(), 'relationalOperator': mRelationalOperatorEnum.GreaterThanOrEqual() },
                { 'Id': 'StopDateUTC', 'Title': localizeWrapper('cEventStop'), 'Type': 'Date', 'DataField': 'StopDateUTC', 'DefaultValue': '', 'relationalOperator': mRelationalOperatorEnum.LessThanOrEqual(), 'relationalOperatorxx': mRelationalOperatorEnum.GreaterThanOrEqual() },
                { 'Id': 'Duration', 'Title': localizeWrapper('cEventLongerThan'), 'Type': 'Dropdown', 'DataSource': lTimeRanges, 'DataValueField': 'Value', 'DataTextField': 'Text', 'DataField': 'Duration', 'DefaultValue': '-1', 'relationalOperator': mRelationalOperatorEnum.GreaterThanOrEqual() }
    //{ 'Id': 'Duration', 'Title': 'Duration', 'Type': 'Dropdown', 'DataField': 'Duration', 'DataSource': [{ 'Value': 15, 'Text': '15 minutes' }, { 'Value': 30, 'Text': '30 minutes' }, { 'Value': 60, 'Text': '1 hour' }, { 'Value': 120, 'Text': '2 hours' }, { 'Value': 240, 'Text': '4 hours' }, { 'Value': 360, 'Text': '6 hours' }, { 'Value': 720, 'Text': '12 hours'}], 'DataValueField': 'Value', 'DataTextField': 'Text', 'DefaultValue': null, 'InsertBlank': true, 'relationalOperator': mRelationalOperatorEnum.LessThanOrEqual() },
        ],
        'Settings': null,
        'UserPreferences': lUserPreferences,
        'UserId': gUserDetails.UserId,
        'UserPreferenceType': 11
    };
    mEventsControls.CardViewFilter = aSender.createControl(
        'uEventsCardViewFilter',
        'uEventsListFilterHolder',
        lParams);

    mEventsControls.CardViewFilter.bind('AllActionableEventchanged', uEventsFilterSelectAll_OnChange);
    mEventsControls.CardViewFilter.bind('EventTypechanged', checkEventFiltersSelecAll);
    mEventsControls.CardViewFilter.filter();
}

function uFilterEventEventsCleaner() {
    var lKey,
    lUnallowed,
    lColumnList = [];

    lUnallowed = ['AllActionableEvent'];

    for (lKey in mEventsControls.CardViewFilter.Columns) {
        var lColumns = mEventsControls.CardViewFilter.Columns[lKey];
        if ($.inArray(lColumns.Id, lUnallowed) < 0) {
            lColumnList.push(lColumns);
        }
    }

    mEventsControls.CardViewFilter.SetSecondaryColumns(lColumnList);
    mEventsControls.CardViewFilter.LiveExpressionModifier();
}

function getActionableEventIds() {
    return ['-1', '21', '41', '121', '9999', '131', '151', '161', '61', '71', '111', '51', '3006', '11', '3008', '3007', '4111', '141', '31', '200'];
}


function checkEventFiltersSelecAll() {
    var lActionableIds = getActionableEventIds(),
        lId = '',
        lEventId = '';
        lCount = 0;

    if (mStateManager.Tab() === 'Enrollees') {
        lId = '#' + mEnrolleesControls.EventsListViewFilter.Id + 'AllActionableEventSelectAll';
        lEventId = '#uEnrolleesEventsListViewFilterEventType';
    } else {
        lId = '#' + mEventsControls.CardViewFilter.Id + 'AllActionableEventSelectAll';
        lEventId = '#uEventsCardViewFilterEventType';
    }

    for (var lKey in lActionableIds) {
        if (lActionableIds.hasOwnProperty(lKey)) {
            if ($(lEventId + lActionableIds[lKey]).prop("checked")) {
                lCount++;
            }
        }
    }
    if (lActionableIds.length - 2 == lCount) {
        $(lId).prop("checked", true);
    } else {
        $(lId).prop("checked", false);
    }
}

function uEventsFilterSelectAll_OnChange() {
    "use strict";
    var lEvents = getEventsFilterMetaEvents(),
        lThis = '',
        lEventId = '',
        lSelect = false,
        lActionableEventIds = getActionableEventIds(),
        lKey;

    if (mStateManager.Tab() === 'Enrollees') {
        lThis = '#' + mEnrolleesControls.EventsListViewFilter.Id + 'AllActionableEventSelectAll';
        lEventId = '#uEnrolleesEventsListViewFilterEventType';
    } else {
        lThis = '#' + mEventsControls.CardViewFilter.Id + 'AllActionableEventSelectAll';
        lEventId = '#uEventsCardViewFilterEventType';
    }

    if ($(lThis).prop("checked")) {
        lSelect = true;
    }
    for (lKey in lEvents) {
        if (lEvents.hasOwnProperty(lKey)) {
            var lCurrentEventId = lEvents[lKey].Id.toString();
            if ($.inArray(lCurrentEventId, lActionableEventIds) > 0) {
                $(lEventId + lEvents[lKey].Id).prop("checked", lSelect);
            }
        }
    }
}

function populateEventsGrid() {
    "use strict";

    if (isNullOrUndefined(mEventsControls.CardView)) {
        uEventsCardView_Init(null, null, null);
    }
    if (isNullOrUndefined(mEventsControls.CardViewFilter)) {
        gFilterFactory_OnEventsInit(gFilterFactory, null, null);
    } else {
        gFilterFactory.Controls.uEventsCardViewFilter.render();
    }
    //gPaginatorFactory_OnEventsInit();
}

function uEventsMapPlayback_OnProgressed(aSender, aEvent, aEventData) {
    "use strict";

    var //lPercentage = ((aEvent.currentIndex + 1) / aEvent.overlayCount) * 100,
        lDate = aEvent.currentPoint.TrackDateUTC,
        lLatitude = aEvent.currentPoint.Latitude,
        lEnrollee = mEventsControls.CardView.selectedDataItem(),
        lTimeZone = getEnrolleeTimeZone(lEnrollee.DataItem.EnrolleeId),
        lLongitude = aEvent.currentPoint.Longitude;
    //  lAddress = uEventsMap_RetrieveAddress(lLatitude, lLongitude);

    if (isNullOrUndefined(lDate)) {
        lDate = aEvent.currentPoint.StartDateUTC;
    }

    function onGeocode(aResult, aStatus, aParams) {
        var lResult = { 'formated_address': '' };

        if (!isNullOrUndefined(aResult)) {
            lResult = aResult;
        }
        $('#uMapPlaybackOutput').html('Trackpoint ' + (aEvent.currentIndex + 1).toString() + ' of ' + aEvent.overlayCount.toString() + ' for ' + lEnrollee.EnrolleeName + ' (' + displayEnrolleeTimeZone(lDate, lTimeZone) + ')' + '&thinsp;   &thinsp;' + ' Latitude ' + lLatitude.toString() + ' Longitude ' + lLongitude.toString() + '</br> Address: ' + lResult.formated_address);
        // $('#uMapPlaybackProgressBar').width(lPercentage.toString() + '%');
        $('#uSlider').slider('option', 'value', aEvent.currentIndex);
    }

    var l = mEventsControls.Map.geocode(lLatitude.toString() + ', ' + lLongitude.toString(), onGeocode);
}

// function used to retrieve address since not in aEvent up above.
//function uEventsMap_RetrieveAddress(aLatitude, aLongitude) {
//    "use strict";
//    var lAddress;
//     lAddress = mEventsControls.Map.geocode(aLatitude.toString() + ', ' + aLongitude.toString(), getGeocodeAddress);

//     function getGeocodeAddress(aResults, aStatus) {
//         "use strict";
//         var lAddress;

//         if (aStatus === 'OK' && aResults.length > 0) {
//             lAddress = aResults[0];
//         }
//         else {
//             lAddress.formatted_address = 'not found';
//         }
//         return lAddress.formatted_address;
//     }
//    return lAddress;
//}

function uEventsMapPlayback_OnCompleted(aSender, aEvent, aEventData) {
    "use strict";
    uEventsMapPlaybackStopButton_OnClick();
}

function eventsPlaybackControl_OnSelectChange(aSender, aEvent, aData) {
    "use strict";
    switch (aEvent.state) {
        case 0: //stopped
            mEventsData.PlaybackStatus = 'Stopped';
            //$('#uEventsMapPlaybackPreviousCell').show();
            //$('#uEventsMapPlaybackPlayButton').show();
            //$('#uEventsMapPlaybackPauseButton').hide();
            //$('#uEventsMapPlaybackStopCell').hide();
            //$('#uEventsMapPlaybackFastForwardCell').hide();
            //$('#uEventsMapPlaybackNextCell').show();

            //hide incorrect active buttons
            $('#uEventsMapPlaybackStopButton').hide();
            $('#uEventsMapPlaybackPauseButton').hide();
            $('#uEventsMapPlaybackFastForwardButton').hide();

            //show correct disabled buttons in their place
            $('#uEventsMapPlaybackStopButtonDisabled').show();
            $('#uEventsMapPlaybackFastForwardButtonDisabled').show();
            $('#uEventsMapPlaybackSlowDownButtonDisabled').show();

            //hide incorrect disabled buttons
            $('#uEventsMapPlaybackPreviousButtonDisabled').hide();
            $('#uEventsMapPlaybackPlayButtonDisabled').hide();
            $('#uEventsMapPlaybackNextButtonDisabled').hide();
            $('#uEventsMapPlaybackSlowDownButton').hide()

            //show correct active buttons in their place
            $('#uEventsMapPlaybackPreviousButton').show();
            $('#uEventsMapPlaybackPlayButton').show();
            $('#uEventsMapPlaybackNextButton').show();


            // show map command cell
            $('.MapCommandCell').show('slow');
            break;
        case 1: //playing
            mEventsData.PlaybackStatus = 'Playing';
            //$('#uEventsMapPlaybackPreviousCell').hide();
            //$('#uEventsMapPlaybackPlayButton').hide();
            //$('#uEventsMapPlaybackPauseButton').show();
            //$('#uEventsMapPlaybackStopCell').show();
            //$('#uEventsMapPlaybackFastForwardCell').show();
            //$('#uEventsMapPlaybackNextCell').hide();

            //hide incorrect active buttons
            $('#uEventsMapPlaybackPreviousButton').hide();
            $('#uEventsMapPlaybackPlayButton').hide();
            $('#uEventsMapPlaybackNextButton').hide();

            //show correct disabled buttons in their place
            $('#uEventsMapPlaybackPreviousButtonDisabled').show();
            $('#uEventsMapPlaybackNextButtonDisabled').show();

            //hide incorrect disabled buttons
            $('#uEventsMapPlaybackStopButtonDisabled').hide();
            $('#uEventsMapPlaybackFastForwardButtonDisabled').hide();
            $('#uEventsMapPlaybackSlowDownButtonDisabled').hide();

            //show correct active buttons in their place
            $('#uEventsMapPlaybackPauseButton').show();
            $('#uEventsMapPlaybackStopButton').show();
            $('#uEventsMapPlaybackFastForwardButton').show();
            $('#uEventsMapPlaybackSlowDownButton').show();

            // show map command cell
            $('.MapCommandCell').hide('slow');
            break;
        case 2: //paused
            if (!isNullOrUndefined(aEvent.currentPoint)) {
                mEventsControls.TrackpointCardView.scrollTop(aEvent.currentPoint.cardViewPrefix + aEvent.currentPoint.Id.toString());
            }
            mEventsData.PlaybackStatus = 'Paused';
            //$('#uEventsMapPlaybackPreviousCell').show();
            //$('#uEventsMapPlaybackPlayButton').show();
            //$('#uEventsMapPlaybackPauseButton').hide();
            //$('#uEventsMapPlaybackStopCell').show();
            //$('#uEventsMapPlaybackFastForwardCell').hide();
            //$('#uEventsMapPlaybackNextCell').show();

            //hide incorrect active buttons
            $('#uEventsMapPlaybackPauseButton').hide();
            $('#uEventsMapPlaybackFastForwardButton').hide();
            $('#uEventsMapPlaybackSlowDownButton').hide();

            //show correct disabled buttons in their place
            $('#uEventsMapPlaybackFastForwardButtonDisabled').show();
            $('#uEventsMapPlaybackSlowDownButtonDisabled').show();

            //hide incorrect disabled buttons
            $('#uEventsMapPlaybackPreviousButtonDisabled').hide();
            $('#uEventsMapPlaybackStopButtonDisabled').hide();
            $('#uEventsMapPlaybackNextButtonDisabled').hide();

            //show correct active buttons in their place
            $('#uEventsMapPlaybackPreviousButton').show();
            $('#uEventsMapPlaybackPlayButton').show();
            $('#uEventsMapPlaybackStopButton').show();
            $('#uEventsMapPlaybackNextButton').show();
            break;
    }
    $('#uMapPlaybackStatus').html(localizeText('cEnrollee' + mEventsData.PlaybackStatus));
}

//function eventsxx(a,b,c){
//    "use strict";
//    var l = '';
//}

function eventsPlacesMarker_OnClick(aSender, aMouseEvent) {
    "use strict";
    veritracks.mapping.placesDetailGenerator(mEventsControls.NotificationPanel, aSender);
}


function eventSlider_OnSlide(aEvent, aUi) {
    "use strict";
    $('#uSlider').slider('option', 'max', mEventsControls.PlaybackControl.getOverlayCount() - 1);

    if (mEventsControls.PlaybackControl.direction() == 1) {
        mEventsControls.PlaybackControl.next();
    } else {
        mEventsControls.PlaybackControl.previous();
    }
    mEventsControls.PlaybackControl.setIndex(aUi.value);
}

function showStreetViewError(aSender, aErrorMessage) {
    alert(aErrorMessage);
}

function uEventMap_Init() {
    "use strict";
    var lSystemPreferences = getUserPreferences(10),
        lDisplayType = 'roadmap',
        lLayerOptions;

    if (!isNullOrUndefined(lSystemPreferences.MapDisplayType)) {
        lDisplayType = lSystemPreferences.MapDisplayType.Value;
    }
    if (!isNullOrUndefined(mEventsData)) {
        mEventsData.PlaybackDivider = 1;
        mEventsData.PlaybackDirection = 1;
        //mEventsData.PlaybackStatus = 'Stopped';
        mEventsControls.Map = new sumo.maps.GoogleMapControl('uEventMap', 'uMapPanel', { 'displayType': lDisplayType, 'mapTypeId_OnChange': mapDisplayType_OnChange, 'OnClick': veritracks.events.mapping.onClick });
        //mEventsControls.Map.bind('distancecalculated', eventsxx, null);
        mEventsControls.Map.bind('streetviewerror', showStreetViewError);
        lLayerOptions = {
            'renderType': 'marker',
            'doesPlayback': true,
            'isVisible': true,
            'isClickable': true,
            'clickEventHandler': veritracks.mapping.eventMarkerClick,
            'zIndexStart': 1000000
        };
        mEventsControls.Map.layerAdd('AllTrackpoints', lLayerOptions);

        lLayerOptions = {
            'renderType': 'marker',
            'doesPlayback': false,
            'isVisible': false,
            'isClickable': false,
            'clickEventHandler': null,
            'zIndexStart': 900000
        };
        mEventsControls.Map.layerAdd('Addresses', lLayerOptions);

        lLayerOptions = {
            'renderType': 'label',
            'doesPlayback': true,
            'isVisible': false,
            'clickEventHandler': null,
            'zIndexStart': 85000
        };
        mEventsControls.Map.layerAdd('Labels', lLayerOptions);

        lLayerOptions = {
            'renderType': 'label',
            'doesPlayback': true,
            'isVisible': false,
            'isClickable': false,
            'clickEventHandler': null,
            'zIndexStart': 800000
        };
        mEventsControls.Map.layerAdd('NumberedLabels', lLayerOptions);

        lLayerOptions = {
            'renderType': 'linesegment',
            'doesPlayback': true,
            'isVisible': false,
            'isClickable': false,
            'clickEventHandler': null,
            'zIndexStart': 700000
        };
        mEventsControls.Map.layerAdd('ConnectedTracks', lLayerOptions);

        mEventsControls.Map.layerAdd('Zones', {
            'renderType': 'geometry',
            'doesPlayback': false,
            'isVisible': true,
            'clickEventHandler': null,
            'zIndexStart': 1000000,
            'shapeChangeHandler': null
        });

        mEventsControls.Map.layerAdd('Selected', {
            'renderType': 'marker',
            'doesPlayback': false,
            'isVisible': true,
            'clickEventHandler': null,
            'zIndexStart': 1200000
        });

        lLayerOptions = {
            'renderType': 'marker',
            'doesPlayback': false,
            'isVisible': true,
            'clickEventHandler': eventsPlacesMarker_OnClick,
            'zIndexStart': 60000,
            'markerImageSize': { 'width': 32, 'height': 32 }
        };
        mEventsControls.Map.layerAdd('Places', lLayerOptions);

        mEventsControls.Map.layerAdd('ZoneNames', {
            'renderType': 'label',
            'doesPlayback': false,
            'isVisible': true,
            'clickEventHandler': null,
            'zIndexStart': 1300000
        });

        mEventsControls.Map.layerAdd('DistancePoints', {
            'renderType': 'marker',
            'doesPlayback': false,
            'isVisible': true,
            'clickEventHandler': null,
            'zIndexStart': 1300000,
            'markerImageSize': { 'width': 32, 'height': 32 }
        });

        mEventsControls.Map.layerAdd('DistanceLabels', {
            'renderType': 'label',
            'doesPlayback': false,
            'isVisible': true,
            'clickEventHandler': null,
            'zIndexStart': 2000000
        });

        mEventsControls.Map.layerAdd('ConnectedDistancePoints', {
            'renderType': 'linesegment',
            'doesPlayback': true,
            'isVisible': true,
            'isClickable': false,
            'clickEventHandler': null,
            'zIndexStart': 700000
        });

        //alchocol test layer
        mEventsControls.Map.layerAdd('AlcoholTestPoints', {
            'renderType': 'marker',
            'doesPlayback': false,
            'isVisible': true,
            'clickEventHandler': enrolleesMapAlcoholMarker_OnClick,
            'zIndexStart': 1300000,
            'markerImageSize': { 'width': 32, 'height': 32 }
        });

        lLayerOptions = {
            'renderType': 'marker',
            'doesPlayback': false,
            'isVisible': true,
            'clickEventHandler': null,
            'zIndexStart': 60000
        };
        mEventsControls.Map.layerAdd('Addresses', lLayerOptions);

        $('#uSlider').slider({ 'min': 0, 'max': 99, 'slide': eventSlider_OnSlide });

        mEventsControls.PlaybackControl = mEventsControls.Map.getPlaybackController('AllTrackpoints');
        mEventsControls.PlaybackControl.bind('progressed', uEventsMapPlayback_OnProgressed);
        mEventsControls.PlaybackControl.bind('completed', uEventsMapPlayback_OnCompleted);
        mEventsControls.PlaybackControl.bind('statechange', eventsPlaybackControl_OnSelectChange);

        populateDateView('#uMapDatePicker', function () {
            var lPreference = new UserPreference(),
                lValue = $('#uMapDatePicker').val() + ' 23:59:59';
            $('#uMapDatePicker').val(lValue);
            mEventsData.MapEndDate = new Date($('#uMapDatePicker').val());
            //offenderMapPopulate();
            lPreference.Id = gUserDetails.UserId;
            lPreference.UserPreferenceType = 4;
            lPreference.ColumnName = 'MapDatePicker';
            lPreference.Value = lValue;
            writeUserPreferences([lPreference]);
        });
        mEventsControls.MapLocate = new sumo.maps.Locate('uMapLocate', 'uLocateMapHolder', mEventsControls.Map, {});
        mEventsControls.MapLocate.bind('complete', eventsPlaces_OnComplete);
    }
}

function uEventMapSettingsListView_OnSelectedChanged(aSender, aSelectedIds) {
    "use strict";
    if (mEventsData.PlaybackStatus !== 'Stopped') {
        uEventsMapPlaybackStopButton_OnClick();
    }
    if (!isNullOrUndefined(mEventsData.CurrentTrackpoints)) {
        if (aSelectedIds.indexOf(1) >= 0) {
            mEventsControls.Map.layerShow('Zones');
        } else if (aSelectedIds.indexOf(1) === -1) {
            mEventsControls.Map.layerHide('Zones');
        }
        if (aSelectedIds.indexOf(3) >= 0) {
            mEventsControls.Map.layerShow('Addresses');
        } else if (aSelectedIds.indexOf(3) === -1) {
            mEventsControls.Map.layerHide('Addresses');
        }
        if (aSelectedIds.indexOf(4) >= 0) {
            if (!mEventsData.MapRenderState.IsConnectedTracks) {
                mEventsControls.Map.layerSetDataSource('ConnectedTracks', veritracks.mapping.prepareTrackpointLineSegmentData(mEventsData.CurrentTrackpoints));
                mEventsData.MapRenderState.IsConnectedTracks = true;
            }
            mEventsControls.Map.layerShow('ConnectedTracks');
        } else if (aSelectedIds.indexOf(4) === -1) {
            mEventsControls.Map.layerHide('ConnectedTracks');
        }
        if (aSelectedIds.indexOf(5) >= 0) {
            if (!mEventsData.MapRenderState.IsNumberedLabels) {
                mEventsControls.Map.layerSetDataSource('NumberedLabels', veritracks.mapping.prepareNumericLabelOverlayData(mEventsData.CurrentTrackpoints));
                mEventsData.MapRenderState.IsNumberedLabels = true;
            }
            mEventsControls.Map.layerShow('NumberedLabels');
        } else if (aSelectedIds.indexOf(5) === -1) {
            mEventsControls.Map.layerHide('NumberedLabels');
        }
        if (aSelectedIds.indexOf(7) >= 0) {
            if (!mEventsData.MapRenderState.IsGpsTrackpoints) {
                mEventsControls.Map.layerSetDataSource('AllTrackpoints', veritracks.mapping.prepareTrackpointMarkerData(mEventsData.CurrentTrackpoints));
                mEventsData.MapRenderState.IsGpsTrackpoints = true;
            }
            mEventsControls.Map.layerShow('AllTrackpoints');
        } else if (aSelectedIds.indexOf(7) === -1) {
            mEventsControls.Map.layerHide('AllTrackpoints');
        }
        mEventsControls.Map.fitBounds();
    }
}

function uMapSettingsListView_Init() {
    "use strict";

    if (isNullOrUndefined(mEventsControls.MapSettingsListView)) {
        var lColumns = [
            { 'id': 'Selection', 'title': '', 'dataField': 'Id', 'width': 'autoData', 'minWidth': 20, 'sortable': false, 'cssClass': null, 'formatMethod': selectionColumnFormatter },
            { 'id': 'Description', 'title': localizeWrapper('cEnrolleeDescription'), 'dataField': 'Description', 'width': 'autoData', 'minWidth': 60, 'sortable': false, 'cssClass': null, 'formatMethod': null }
        ],
        i,
        lSetting,
        lSettings = [];

        for (i = 0; i < gMapSettings.length; i++) {
            lSetting = gMapSettings[i];
            if (lSetting.Id !== 6 && lSetting.Id !== 2) {
                lSettings.push(lSetting);
            }
        }
        //mEventsData.MapSettingsIds = [];
        mEventsControls.MapSettingsListView = new sumo.controls.ListView(
            'uMapSettingsListView',
            'uMapSettingsContent',
            { 'keyField': 'Id', 'selectMethod': 'auto', 'cssClass': 'VeritracksSelectListView', 'canUnselect': true, 'showHeader': false },
            lColumns);
        mEventsControls.MapSettingsListView.setDataSource(lSettings);
        mEventsControls.MapSettingsListView.bind('selectedchanged', uEventMapSettingsListView_OnSelectedChanged, null);
        //        ({ 'Id': 1, 'Description': 'Show Zones' });
        //        ({ 'Id': 2, 'Description': 'Lock StartDate' });
        //        ({ 'Id': 3, 'Description': 'Show Enrollee Addresses' });
        //        ({ 'Id': 4, 'Description': 'Show Connected Tracks' });
        //        ({ 'Id': 5, 'Description': 'Show Numbered Labels' });
        //        ({ 'Id': 6, 'Description': 'Show Events' });
        //        ({ 'Id': 7, 'Description': 'Show GPS Trackpoints' });
        //        ({ 'Id': 8, 'Description': 'Show Cell Tower Trackpoints' });
        mEventsControls.MapSettingsListView.selected([3, 7, 8]);
    }
}

function mStateManagerEventsPrimary_Init(aPrevious, aCurrent) {
    "use strict";
    if (!isNullOrUndefined(aCurrent.Settings[1]) && aCurrent.Settings[1] !== 'null') {
        mEventsData.TargetId = parseInt(aCurrent.Settings[1]);
        mStateManager.ChangeSettings(1, null);
        mEventsControls.CardViewFilter.filter();
    }
    // localize here
    veritracks.localization.localizeTitle();
}

function mStateManagerEventsLayout_OnComplete() {
    "use strict";
    applyUserPermissions([1, 33, 32]);
    resetContentHolders();
    //populateElement('uMapLegendContent', 'Map.Legend.htm', null);
    //populateElement('uMapLocateContent', 'Map.Locate.htm', null);
    //populateElement('uMapDetailsContent', 'Events.Map.Details.htm', null);
    //populateElement('uLocateMapHolder', 'Map.Locate.htm', null);
    mEventsControls.NotificationPanel = new SumoActivityNotification('uMapNotificationPanel', 'uEventsMapPanel', 50, { 'allowClose': true });
    mEventsControls.NotificationPanel.render();

    uEventMap_Init();
    eventsTrackPointCardView_Init();
    populateEventsGrid();
    eventsTrackPointCardViewFilter_Init();
    mEventsControls.NotesDropdown = new sumo.controls.Dropdown('EventNotesButton', 'uEventsNotesHeaderHolder', {
        'title': localizeWrapper('cEventViewNotes'),
        'viewportType': 'inline',
        'contentType': 'jQueryElement',
        'isOpen': false,
        'cssClass': 'EventNotes',
        'content': $('#uEventsNotesHolder')
    });
    //uMapSettingsListView_Init();
    uEventsCardViewSortOnViewState();
    mStateManagerEventsPrimary_Init(null, mStateManager.Hash());
    //added for page refresh
    if (gUserDetails.RegionalOri && (getViewState("isRegionalLoaded") == null || getViewState("isRegionalLoaded") == false)) {
        uMasterMenuPanel_OnClick($('#uEventsTab'), 'Enrollees.Offenders.Profile.Events');
    }
}

function mStateManagerEventsLayout_Init(aPrevious, aCurrent) {
    "use strict";
    var lFilename = 'Events.' + aCurrent.Settings[0] + '.Layout.htm';
    populateElement('uEventsMainContentPanel', lFilename, mStateManagerEventsLayout_OnComplete);
}

function mStateManagerEvents_OnComplete() {
    "use strict";
    //defaultAlert('mStateManagerEvents_OnComplete');
    resetContentHolders();
    applyUserPermissions([1, 32]);
    $('#uMasterMenuPanel').show();
    mStateManagerEventsLayout_Init(null, mStateManager.Hash());
    //populateEventsGrid();
}

function mStateManagerEvents_Init(aPrevious, aCurrent) {
    "use strict";
    var lLayout = aCurrent.Tab + '.Layout.htm';
    //defaultAlert('mStateManagerEvents_Init1');
    if (applyUserPermissionsNavigation(gPageClassManager.System, aCurrent.Tab)) {
        //defaultAlert('mStateManagerEvents_Init2');
        mEventsData = new EventsData();
        //defaultAlert('mStateManagerEvents_Init3');
        generateEventData();
        //defaultAlert('mStateManagerEvents_Init4');
        mCache.bind('Eventsupdated', eventsDataItem_Updated, null);
        //defaultAlert('mStateManagerEvents_Init5');
        populateElement('uMasterContentHolder', lLayout, mStateManagerEvents_OnComplete);
        //defaultAlert('mStateManagerEvents_Init6');
        mEventsControls.CardViewTimer = new TimerManager(500);
    }
}

function mStateManagerEventsLayout_Leave(aPrevious, aCurrent) {
    "use strict";
}

function mStateManagerEvents_Leave(aPrevious, aCurrent) {
    "use strict";

    mEventsData = null;
    mCache.unbind('Eventsupdated', eventsDataItem_Updated);
    //mCache.unbind('Enrolleesupdated', eventsDataItem_Updated);

    if (!isNullOrUndefined(mEventsControls.CardView)) {
        mEventsControls.CardView.dispose();
        mEventsControls.CardView = null;
    }
    if (!isNullOrUndefined(mEventsControls.CardViewFilter)) {
        mEventsControls.CardViewFilter.dispose();
        mEventsControls.CardViewFilter = null;
    }
    if (!isNullOrUndefined(mEventsControls.CardViewPaginator)) {
        mEventsControls.CardViewPaginator.dispose();
        mEventsControls.CardViewPaginator = null;
    }
    if (!isNullOrUndefined(mEventsControls.Map)) {
        mEventsControls.Map.dispose();
        mEventsControls.Map = null;
    }
    if (!isNullOrUndefined(mEventsControls.MapLocate)) {
        mEventsControls.MapLocate.bind('complete', eventsPlaces_OnComplete);
        mEventsControls.MapLocate.dispose();
        mEventsControls.MapLocate = null;
    }
    if (!isNullOrUndefined(mEventsControls.MapSettingsListView)) {
        mEventsControls.MapSettingsListView.dispose();
        mEventsControls.MapSettingsListView = null;
    }
    if (!isNullOrUndefined(mEventsControls.PlaybackControl)) {
        mEventsControls.PlaybackControl.unbind('progressed', uEventsMapPlayback_OnProgressed);
        mEventsControls.PlaybackControl.unbind('completed', uEventsMapPlayback_OnCompleted);
        mEventsControls.PlaybackControl.dispose();
        mEventsControls.PlaybackControl = null;
    }
    if (!isNullOrUndefined(mEventsControls.TrackpointCardView)) {
        mEventsControls.TrackpointCardView.dispose();
        mEventsControls.TrackpointCardView = null;
    }
    if (!isNullOrUndefined(mEventsControls.TrackpointCardViewFilter)) {
        mEventsControls.TrackpointCardViewFilter.dispose();
        mEventsControls.TrackpointCardViewFilter = null;
    }
    mEventsControls.NotesManager = null;

    if (!isNullOrUndefined(mEventsControls.NotesDropdown)) {
        mEventsControls.NotesDropdown.dispose();
        mEventsControls.NotesDropdown = null;
    }
    if (!isNullOrUndefined(mEventsControls.NotificationPanel)) {
        mEventsControls.NotificationPanel.dispose();
        mEventsControls.NotificationPanel = null;
    }

    if (!isNullOrUndefined(mEventsControls.CardViewTimer)) {
        mEventsControls.CardViewTimer = null;
    }

    mStateManagerEventsLayout_Leave(aPrevious, aCurrent);
}

function eventConfirmation_OnLoad(aParams, aData) {
    "use strict";

    if (aParams === mEventsData.CurrentId) {
        var lIsConfirmed = true;
        if (isNullOrUndefined(aData.Data) || aData.Data.length === 0) {
            lIsConfirmed = false;
        }
        if (!lIsConfirmed) {
            $('#uConfirmEventButton').show();
            $('#uIsConfirmedMessage').hide();
        }
    }
}

function eventConfirmation_OnFailure(aParams, aData) {
    "use strict";
}


// EVENTS

//function uEventsMapLocateButton_OnClick(aLocateText) {
//    "use strict";
//    mEventsControls.Map.locate(aLocateText, veritracks.mapping.mapLocate_Complete);
//}
function eventsPlaces_OnComplete(aSender, aPlaceList) {
    "use strict";
    var lLength = aPlaceList.length,
        lPlace,
        lType;

    mEventsControls.Map.clearStreetView();

    mEventsControls.NotificationPanel.clearNotifications();
    if (lLength > 0) {
        lPlace = aPlaceList[0];
        lType = lPlace.types[0];
    }

    if (lLength === 1 && !isNullOrUndefined(lPlace) && (lType === 'street_address' || lType === 'locality')) {
        mEventsControls.Map.layerSetDataSource('Places', veritracks.mapping.preparePlacesData(aPlaceList));
        mEventsControls.Map.setCenter(lPlace.geometry.location.lat(), lPlace.geometry.location.lng());
        mEventsControls.Map.zoom(17);
    } else if (lLength >= 1) {
        mEventsControls.Map.layerSetDataSource('Places', veritracks.mapping.preparePlacesData(aPlaceList));
        mEventsControls.Map.setCenter(lPlace.geometry.location.lat(), lPlace.geometry.location.lng());
        mEventsControls.Map.zoom(14);
    } else {
        mEventsControls.Map.layerSetDataSource('Places', veritracks.mapping.preparePlacesData(aPlaceList));
    }
}

//function uEventsMapLocateButton_OnClick(aLocateText) {
//    "use strict";
//    mEventsControls.Map.locatePlaces(aLocateText, veritracks.mapping.mapLocate_Complete);
//}

// PLAYBACK

function uEventsMapPlaybackNextButton_OnClick() {
    "use strict";
    if (mEventsData.PlaybackStatus === 'Stopped') {
        $('#uSlider').slider('option', 'max', mEventsControls.PlaybackControl.getOverlayCount() - 1);
    }
    //mEventsData.PlaybackStatus = 'Paused';
    mEventsControls.PlaybackControl.next();
}

function uEventsMapPlaybackPreviousButton_OnClick() {
    "use strict";
    if (mEventsData.PlaybackStatus === 'Stopped') {
        $('#uSlider').slider('option', 'max', mEventsControls.PlaybackControl.getOverlayCount() - 1);
    }
    //mEventsData.PlaybackStatus = 'Paused';
    mEventsControls.PlaybackControl.previous();
}

function uEventsMapPlaybackRewindButton_OnClick() {
    "use strict";

    if (mEventsData.PlaybackStatus === 'Playing' || mEventsData.PlaybackStatus === 'Rewinding') {
        if (mEventsData.PlaybackDirection === -1) {
            switch (mEventsData.PlaybackDivider) {
                case 1:
                    mEventsData.PlaybackDivider = 2;
                    break;
                case 2:
                    mEventsData.PlaybackDivider = 4;
                    break;
                case 4:
                    mEventsData.PlaybackDivider = 8;
                    break;
                case 16:
                    mEventsData.PlaybackDivider = 1;
                    break;
            }
        } else {
            //mEventsData.PlaybackStatus = 'Rewinding';
            //$('#uMapPlaybackStatus').html(mEventsData.PlaybackStatus);
            mEventsData.PlaybackDirection = -1;
            mEventsData.PlaybackDivider = 1;
            mEventsControls.PlaybackControl.direction(mEventsData.PlaybackDirection);
        }
        mEventsControls.PlaybackControl.speed(mEventsData.PlaybackDivider);
        $('#uMapPlaybackSpeed').html('(' + mEventsData.PlaybackDivider + 'x)');
    }
}

function uEventsMapPlaybackPlayButton_OnClick() {
    "use strict";
    $('#uSlider').slider('option', 'max', mEventsControls.PlaybackControl.getOverlayCount() - 1);

    //if (mEventsData.PlaybackDirection === 1) {
    //    mEventsData.PlaybackStatus = 'Playing';
    //} else {
    //    mEventsData.PlaybackStatus = 'Rewinding';
    //}
    //$('#uEventsMapPlaybackPlayButton').hide();
    //$('#uEventsMapPlaybackStopCell').show();
    //$('#uEventsMapPlaybackPauseButton').show();
    //$('#uMapPlaybackStatus').html(mEventsData.PlaybackStatus);
    $('#uMapPlaybackSpeed').html('(' + mEventsData.PlaybackDivider + 'x)');
    mEventsControls.PlaybackControl.start();
}

function uEventsMapPlaybackPauseButton_OnClick() {
    "use strict";
    $('#uSlider').slider('option', 'max', mEventsControls.PlaybackControl.getOverlayCount() - 1);
    mEventsControls.PlaybackControl.pause();
    //mEventsData.PlaybackStatus = 'Paused';
    //$('#uEventsMapPlaybackPauseButton').hide();
    //$('#uEventsMapPlaybackPlayButton').show();
    //$('#uMapPlaybackStatus').html(mEventsData.PlaybackStatus);
    $('#uMapPlaybackSpeed').html('');
}

function uEventsMapPlaybackFastForwardButton_OnClick() {
    "use strict";

    if (mEventsData.PlaybackStatus === 'Playing' || mEventsData.PlaybackStatus === 'Rewinding') {
        if (mEventsData.PlaybackDirection === 1) {
            switch (mEventsData.PlaybackDivider) {
                case 1:
                    mEventsData.PlaybackDivider = 2;
                    break;
                case 2:
                    mEventsData.PlaybackDivider = 4;
                    break;
                case 4:
                    mEventsData.PlaybackDivider = 8;
                    break;
                case 8:
                    mEventsData.PlaybackDivider = 1;
                    break;
            }
        } else {
            //mEventsData.PlaybackStatus = 'Playing';
            //$('#uMapPlaybackStatus').html(mEventsData.PlaybackStatus);
            mEventsData.PlaybackDirection = 1;
            mEventsData.PlaybackDivider = 1;
            mEventsControls.PlaybackControl.direction(mEventsData.PlaybackDirection);
        }
        mEventsControls.PlaybackControl.speed(mEventsData.PlaybackDivider);
        $('#uMapPlaybackSpeed').html('(' + mEventsData.PlaybackDivider + 'x)');
    }
}

// slow down function for iteration 3? use in wherever slowdown is required
function uEventsMapPlaybackSlowDownButton_OnClick() {
    "use strict";

    if (mEventsData.PlaybackStatus === 'Playing' || mEventsData.PlaybackStatus === 'Rewinding') {
        if (mEventsData.PlaybackDirection === 1) {
            switch (mEventsData.PlaybackDivider) {
                case 1:
                    mEventsData.PlaybackDivider = 0;
                    break;
                case 2:
                    mEventsData.PlaybackDivider = 1;
                    break;
                case 4:
                    mEventsData.PlaybackDivider = 2;
                    break;
                case 8:
                    mEventsData.PlaybackDivider = 4;
                    break;
            }
        } else {
            //mEnrolleesData.PlaybackStatus = 'Playing';
            //$('#uMapPlaybackStatus').html(mEnrolleesData.PlaybackStatus);
            mEventsData.PlaybackDirection = 1;
            mEventsData.PlaybackDivider = 1;
            mEventsControls.PlaybackControl.direction(mEventsData.PlaybackDirection);
        }
        if (mEventsData.PlaybackDivider == 0) {
            uEventsMapPlaybackPauseButton_OnClick();
            mEventsData.PlaybackDivider = 1;
        }
        else {
            mEventsControls.PlaybackControl.speed(mEventsData.PlaybackDivider);
            $('#uMapPlaybackSpeed').html('(' + mEventsData.PlaybackDivider + 'x)');
        }
    }
}

function eventCloseWrite_OnFailure(a, b, c) {
    "use strict";
    $('#uEventsEventCloseButton').show();
    $('#uIsConfirmedMessage').hide();
}

function eventConfirmationWrite_OnFailure(a, b, c) {
    "use strict";
    $('#uConfirmEventButton').show();
    $('#uIsConfirmedMessage').hide();
}

function eventConfirmationWrite_OnSuccess(aParams, aItem) {
    "use strict";
    if (aItem.Id > 0) {
        FixDates(aItem);
        setDataItem(aItem.Id, 'Events', aItem);
        generateEventData();
        mEventsControls.CardViewFilter.filter();
        mActivityNotification.addNotification(localizeWrapper('cEventEventConfirmed'));
        UpdateEnrolleeEventReports(aItem);
    } else {
        if (aItem.MetaEventId === 1003) {
            eventCloseWrite_OnFailure();
            if (aItem.Id === -3) {
                mActivityNotification.addNotification(localizeWrapper('cEventStrapConfirmProblem'));
            }
        } else {
            eventConfirmationWrite_OnFailure();
        }
    }
}




function uEventsEventCloseButton_OnClick() {
    "use strict";
    var lEvents = getDataItems('Events'),
        lEventAncestor = lEvents[mEventsData.CurrentId],
        lEventDescendent = null;

    $('#uEventsEventCloseButton').hide();
    lEventDescendent = $.extend({}, lEventAncestor);
    if (!lEventDescendent.IsConfirmed) {
        lEventDescendent.IsConfirmed = true;
        lEventDescendent.ConfirmedByUserId = gUserDetails.UserId;
        lEventDescendent.ConfirmedDateUTC = new Date();
    }
    lEventDescendent.IsOpen = false;
    lEventDescendent.StopDateUTC = lEventDescendent.ConfirmedDateUTC;
    lEventDescendent = prepareObjectForWcf(lEventDescendent);
    WriteSingle(lEventDescendent, eventConfirmationWrite_OnSuccess, eventCloseWrite_OnFailure);
}

function uEventConfirmWindowNote_OnAdd(aEvent) {
    "use strict";
    var lNoteText = $('#uEventNoteText').val(),
        lNote = null,
        lOriginalNote = null;

    if ($.trim(lNoteText) !== '') {
        lOriginalNote = new Note(gUserDetails.UserId, lNoteText);
        lOriginalNote.__type = 'Event' + lOriginalNote.__type;

        if (lOriginalNote !== null) {
            lNote = $.extend({}, lOriginalNote);
            lNote.EventId = mEventsData.CurrentId;
        }
        WriteSingle(lNote, eventNoteWrite_OnSuccess, eventNoteWrite_OnFailure, aEvent);
    }
}

function uConfirmEventButton_OnClick() {
    "use strict";
    var lEvents = getDataItems('Events'),
        lEventAncestor = lEvents[mEventsData.CurrentId],
        lEventDescendent = null,
        lNoteText = $('#uEventNoteText').val();
    $('#uConfirmEventButton').hide();
    if (!isNullOrUndefined(lEventAncestor)) {
        delete lEventAncestor.AgentofRecord;
        lEventDescendent = $.extend({}, lEventAncestor);

        lEventDescendent.IsConfirmed = true;
        lEventDescendent.ConfirmedByUserId = gUserDetails.UserId;
        lEventDescendent.ConfirmedDateUTC = new Date();
        lEventDescendent.TransactionId = moment().format("YYYYMMDDHHmmss");
        lEventDescendent.__type = "Event:www.veritracks.com";
        lEventDescendent = prepareObjectForWcf(lEventDescendent);
    }
    else {
        lEventAncestor = mEventsControls.CardView.selectedDataItem();
        lEventDescendent = $.extend({}, lEventAncestor.DataItem);
        lEventDescendent.IsConfirmed = true;
        lEventDescendent.ConfirmedByUserId = gUserDetails.UserId;
        lEventDescendent.ConfirmedDateUTC = new Date();
        lEventDescendent.TransactionId = moment().format("YYYYMMDDHHmmss");
        lEventDescendent.__type = "Event:www.veritracks.com";
        lEventDescendent = prepareObjectForWcf(lEventDescendent);
    }

    WriteSingle(lEventDescendent, eventConfirmationWrite_OnSuccess, eventConfirmationWrite_OnFailure);
    if ($.trim(lNoteText) !== '') {
        uEventConfirmWindowNote_OnAdd(lEventDescendent);
    }
    ClosePopup();
}


function eventsMapPanel_OnClick() {
    "use strict";
    if ($('#uEnrolleesListCell').is(':visible') || $('#uMapDetailPanelCell').is(':visible')) {
        $('#uExpandMapButton').addClass('ExpandMapButton').removeClass('ContractMapButton');
    } else {
        $('#uExpandMapButton').removeClass('ExpandMapButton').addClass('ContractMapButton');
    }
    if ($('#uMapDetailPanelCell').is(':visible')) {
        mEventsControls.NotificationPanel.clearNotifications();
        mEventsControls.TrackpointCardView.scrollTop(mEventsControls.TrackpointCardView.selected());
    }
    resetContentHoldersEvents();
}

function uExpandEventsMapButtonButton_OnClick(aSender) {
    "use strict";
    if ($(aSender).hasClass('ExpandMapButton')) {
        veritracks.mapping.setMapPanelDisplay($('#uPrimaryMapCollapsePanel'), 'uEventsListCell', false, eventsMapPanel_OnClick);
        veritracks.mapping.setMapPanelDisplay($('#uSecondaryMapCollapsePanel'), 'uMapDetailPanelCell', false, eventsMapPanel_OnClick);
    } else {
        veritracks.mapping.setMapPanelDisplay($('#uPrimaryMapCollapsePanel'), 'uEventsListCell', true, eventsMapPanel_OnClick);
        veritracks.mapping.setMapPanelDisplay($('#uSecondaryMapCollapsePanel'), 'uMapDetailPanelCell', true, eventsMapPanel_OnClick);
    }
}

function uEventsViewNotesButton_OnClick() {
    "use strict";
    $('#uEventsNotesHolder').slideToggle();
    toggleNotesDropdown('Events');
}

function uEventsNoteText_OnChange() {
    "use strict";
    var lEventNoteTextValue = $('#uEventNoteText').val();
    if ($.trim(lEventNoteTextValue) !== '') {
        $('.EventsAddNoteButton').removeClass('Disabled');
    } else {
        $('.EventsAddNoteButton').addClass('Disabled');
    }
}


function uConfirmCommandButton_OnClick() {
    "use strict";
    var lButtonBar = GenerateButtonCommandBar(),
        lHtml = [],
        lColumns = [],
        lSelectedEvent = mEventsControls.CardView.selectedDataItem(),
        lBuilder = new SumoPredicateBuilder(),
        lTrackpoints = $('#uEventsDetailTrackPointCount' + mEventsData.CurrentId).text();

    lHtml.push('<div class="" style="background-color: white">');
    lHtml.push(' <table cellpadding="0" cellspacing="0" border="0" style="margin-top: 1px">');
    lHtml.push(' <tr class="pEventsNotesWrite">');
    lHtml.push(' <td>' + localizeWrapper('cEventNotes') + '</td>');
    lHtml.push(' <td>&nbsp;<input id="uEventNoteText" type="text" name="uEventNoteText" style="width:420px;"  /></td>');
    lHtml.push(' </tr>');
    lHtml.push(' </table>');
    lHtml.push('</div>');
    lHtml.push('<div style="height: 200px;" id="uEventConfirmWindowDetailsHolder">');


    lHtml.push('<div style="float:left;">');
    lHtml.push('<div class="Property PropertyTitle Ellipsis" style="width: 215px;" title="##MetaEventDescription##">');
    lHtml.push(lSelectedEvent.MetaEventDescription);
    lHtml.push('</div>');

    lHtml.push('<div class="Property EnrolleeIconProperty Ellipsis">');
    lHtml.push(lSelectedEvent.EnrolleeName);
    lHtml.push('</div>');

    lHtml.push('<div class="Property TimeIconProperty">'+localizeWrapper('cAnalysisStart')+':');
    lHtml.push(lSelectedEvent.StartDateDisplay);
    lHtml.push('</div>');

    lHtml.push('<div class="Property TimeIconProperty">' + localizeWrapper('cEventStop') + ': ');
    lHtml.push(lSelectedEvent.StopDateDisplay);
    lHtml.push('</div>');

    lHtml.push('<div class="Property InventoryIconProperty">' + localizeWrapper('cInventoryDevice') + ':');
    lHtml.push(lSelectedEvent.SerialNumber);
    lHtml.push('</div>');

    lHtml.push('<div class="Property ConfirmedIconProperty">' + localizeWrapper('cEventIsConfirmed') + ': ');
    lHtml.push(lSelectedEvent.IsConfirmedDisplay);
    lHtml.push('</div>');

    lHtml.push('</div>');

    lHtml.push('<div style="float:left;">');

    lHtml.push('<div class="Property AgentIconProperty">' + localizeWrapper('cEventConfirmedBy') + ': ');
    lHtml.push(lSelectedEvent.ConfirmedByName);
    lHtml.push('</div>');

    lHtml.push('<div class="Property TimeIconProperty">' + localizeWrapper('cEventConfirmedOn') + ': ');
    lHtml.push(lSelectedEvent.ConfirmedDateUTC);
    lHtml.push('</div>');

    lHtml.push('<div class="Property TrackpointIconProperty">'+ localizeWrapper('cEventTotalPoints') + ': ');
    lHtml.push(lTrackpoints);
    lHtml.push('</div>');

    lHtml.push('<div class="HeightProperty ZoneIconProperty">' + localizeWrapper('cZone') + ': ');
    lHtml.push(lSelectedEvent.ZoneName);
    lHtml.push('</div>');

    lHtml.push('<div class="Property TrackpointIconProperty">' + localizeWrapper('cEventZonePoints') + ': ');
    lHtml.push(lSelectedEvent.ZoneTrackPointCount);
    lHtml.push('</div>');

    lHtml.push('<div class="Property NotesIconProperty">' + localizeWrapper('cEventHasNotes') + ': ');
    lHtml.push(lSelectedEvent.HasNotesDisplay);
    lHtml.push('</div>');

    lHtml.push('</div>');

    lHtml.push('</div>');

    GenerateButton(localizeWrapper('cEnrolleeAddNote'), 'pEventsNotesWrite EventsAddNote', 'uEventConfirmWindowNote_OnAdd();').appendTo(lButtonBar);
    GenerateButton(localizeWrapper('cEventConfirm'), 'pEventsWrite ConfirmEvent', 'uConfirmEventButton_OnClick();').appendTo(lButtonBar);

    DisplayPopup(localizeWrapper('cEventConfirmEvent'), lHtml.join(''), lButtonBar, false);
    applyUserPermissions([1, 32]);
    $('#uEventNoteText').change(uEventsNoteText_OnChange).keyup(uEventsNoteText_OnChange).keypress(uEventsNoteText_OnChange).change();
}

veritracks.events.mapping.data = {
    'DoGeocode': false,
    'DoDistanceCalculation': false
};

// geocode
veritracks.events.mapping.onClick = function (aEvent) {
    "use strict";
    var lDoMetric =  parseInt(getUserPreferenceValue(13,'ShowMetric'));
    function onGeocode(aResult, aStatus, aParams) {
        var lResult,
            lHtml = [];
        if (aStatus === 'OK') {
            lResult = aResult;
            lHtml.push('<h3>Address</h3>');
            lHtml.push(lResult.formated_address);
            lHtml.push('<h3>Latitude</h3>');
            lHtml.push(lResult.geometry.location.lat());
            lHtml.push('<h3>Longitude</h3>');
            lHtml.push(lResult.geometry.location.lng());
            mEventsControls.NotificationPanel.clearNotifications();
            mEventsControls.NotificationPanel.addNotification(lHtml.join(''), true);
        }
    }

    if (veritracks.events.mapping.data.DoDistanceCalculation) {
        if (lDoMetric) {
            eventsCalculateDistance(aEvent, new Unit().MEASURE.METRIC);
        } else {
            eventsCalculateDistance(aEvent);
        }
    } else if (veritracks.events.mapping.data.DoGeocode) {
        eventsGeocodeToolBar_OnClick();
        mEventsControls.Map.geocode(aEvent.latLng.lat().toString() + ', ' + aEvent.latLng.lng().toString(), onGeocode, null);
    }
};

function eventsGeocodeToolBar_OnClick() {
    "use strict";
    if (veritracks.events.mapping.data.DoGeocode) {
        veritracks.events.mapping.data.DoGeocode = false;
        $('#uGeocodeToolBarButton').removeClass('Selected');
    } else {
        if (veritracks.events.mapping.data.DoDistanceCalculation) {
            eventsDistanceToolBar_OnClick();
        }
        veritracks.events.mapping.data.DoGeocode = true;
        $('#uGeocodeToolBarButton').addClass('Selected');
    }
}


// distance
function eventsCalculateDistance(aClickData, aUnit) {
    "use strict";
    var lLatitude = aClickData.latLng.lat(),
        lLongitude = aClickData.latLng.lng(),
        lResult,
        lCard;
    function onComplete(aDistance, aLatitude, aLongitude) {
        "use strict";
        mEventsControls.Map.layerSetDataSource('DistanceLabels', veritracks.mapping.prepareDistanceLabelOverlayData([{ 'latitude': aLatitude, 'longitude': aLongitude, 'text': aDistance }]));
        mEventsControls.Map.layerSetDataSource('ConnectedDistancePoints', veritracks.mapping.prepareTripPointLineSegmentData(mEventsData.DistancePoints));
    }

    if (veritracks.events.mapping.data.DoDistanceCalculation) {
        if (!isNullOrUndefined(lLatitude) && !isNullOrUndefined(lLongitude)) {
            if (mEventsData.DistancePoints.length >= 2) {
                mEventsData.DistancePoints = [];
                mEventsControls.Map.layerSetDataSource('DistancePoints', veritracks.mapping.prepareDistanceMarkerData([]));
                mEventsControls.Map.layerSetDataSource('DistanceLabels', veritracks.mapping.prepareDistanceLabelOverlayData([]));
                mEventsControls.Map.layerSetDataSource('ConnectedDistancePoints', veritracks.mapping.prepareTripPointLineSegmentData([]));
            }
            lCard = new DistanceCard();
            lCard.latitude = lLatitude;
            lCard.longitude = lLongitude;
            if (isNullOrUndefined(mEventsData.DistancePoints)) {
                mEventsData.DistancePoints.push(lCard);
            } else {
                mEventsData.DistancePoints.push(lCard);
            }
            if (mEventsData.DistancePoints.length > 1) {
                if (isNullOrUndefined(aUnit)) {
                    lResult = veritracks.mapping.calculateDistances(mEventsData.DistancePoints[0].latitude, mEventsData.DistancePoints[0].longitude, mEventsData.DistancePoints[1].latitude, mEventsData.DistancePoints[1].longitude, 'events');
                } else {
                    if (aUnit.name == "Metric") {
                        lResult = veritracks.mapping.calculateDistancesMetric(mEventsData.DistancePoints[0].latitude, mEventsData.DistancePoints[0].longitude, mEventsData.DistancePoints[1].latitude, mEventsData.DistancePoints[1].longitude, 'events');
                    } else {
                        lResult = veritracks.mapping.calculateDistances(mEventsData.DistancePoints[0].latitude, mEventsData.DistancePoints[0].longitude, mEventsData.DistancePoints[1].latitude, mEventsData.DistancePoints[1].longitude, 'events');
                    }
                }
                onComplete(lResult.distanceDisplay, lResult.endPoint.latitude, lResult.endPoint.longitude);
            }
            mEventsControls.Map.layerSetDataSource('DistancePoints', veritracks.mapping.prepareDistanceMarkerData(mEventsData.DistancePoints));
        }
    }
}

function eventsDistanceToolBar_OnClick() {
    "use strict";
    if (veritracks.events.mapping.data.DoDistanceCalculation) {
        veritracks.events.mapping.data.DoDistanceCalculation = false;
        $('#uDistanceToolCommandButton').removeClass('Selected');
        //$('#uDistanceToolHolder').addClass('DistanceToolBarButton').removeClass('DistanceToolBarButtonActive');
        mEventsData.DistancePoints = [];
        mEventsControls.Map.layerSetDataSource('DistancePoints', veritracks.mapping.prepareDistanceMarkerData([]));
        mEventsControls.Map.layerSetDataSource('DistanceLabels', veritracks.mapping.prepareDistanceLabelOverlayData([]));
        mEventsControls.Map.layerSetDataSource('ConnectedDistancePoints', veritracks.mapping.prepareTripPointLineSegmentData([]));
    } else {
        if (veritracks.events.mapping.data.DoGeocode) {
            eventsGeocodeToolBar_OnClick();
        }
        veritracks.events.mapping.data.DoDistanceCalculation = true;
        $('#uDistanceToolCommandButton').addClass('Selected');
        //$('#uDistanceToolHolder').removeClass('DistanceToolBarButton').addClass('DistanceToolBarButtonActive');
    }
}

function UpdateEnrolleeEventReports(aEvents) {
    "use strict";
    var lKey;

    for (lKey in aEvents) {
        if (aEvents.hasOwnProperty(lKey)) {
            UpdateEnrolleeReports(aEvents[lKey].EnrolleeId, aEvents[lKey].OrganizationId, aEvents[lKey].MetaEventId);
        }
    }
}

function UpdateEnrolleeReports(aEnrolleeId, aOrganizationId, aMetaEventId) {
    "use strict";
    var lEnrolleeReports = [];
    var lEnrolleeReport = new EnrolleeReport();
    var lBuilder = new SumoPredicateBuilder();
    var lEvents;
    var lValue;
    var lMetricId = -1;
    var lMetricIds = [];
    var lKey;

    lBuilder.AddNewExpressionConditional('MetaEventId', aMetaEventId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());

    lMetricIds = query(getDataItems('MetricMetaEvent'), lBuilder.RootExpression);
    lBuilder.Clear();
    lBuilder.AddNewExpressionConditional('EnrolleeId', aEnrolleeId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    lBuilder.AddNewExpressionConditional('DisplayFlag', 1, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    lEvents = query(getDataItems('Events'), lBuilder.RootExpression);

    for (lKey in lMetricIds) {
        if (lMetricIds.hasOwnProperty(lKey)) {
            lMetricId = lMetricIds[lKey].Id;
            lValue = evaluateEnrolleeReportMetric(lMetricId, lEvents);

            lEnrolleeReport = new EnrolleeReport();
            lEnrolleeReport.Id = aEnrolleeId;
            lEnrolleeReport.OrganizationId = aOrganizationId;
            lEnrolleeReport.MetricId = lMetricId;
            lEnrolleeReport.Value = lValue;

            lEnrolleeReports.push(lEnrolleeReport);
        }
    }

    WriteMultiple(lEnrolleeReports, null, Sad, null, false);
}

function evaluateEnrolleeReportMetric(aMetricId, aEventList) {
    "use strict";
    var lBuilder = new SumoPredicateBuilder(),
        lMetricMetaEvents = getDataItems('MetricMetaEvent'),
        lMetricMetaEventQuery,
        lMetaEventIds = [],
        lEventQuery,
        lItem,
        lKey;

    lBuilder.AddNewExpressionConditional('Id', aMetricId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    lMetricMetaEventQuery = query(lMetricMetaEvents, lBuilder.RootExpression);

    for (lKey in lMetricMetaEventQuery) {
        if (lMetricMetaEventQuery.hasOwnProperty(lKey)) {
            lItem = lMetricMetaEventQuery[lKey];
            lMetaEventIds.push(lItem.MetaEventId);
        }
    }

    lBuilder.Clear();
    lBuilder.AddNewExpressionConditional('MetaEventId', lMetaEventIds, false, mRelationalOperatorEnum.In(), mLogicalOperatorEnum.And());
    lEventQuery = query(aEventList, lBuilder.RootExpression);
    return evaluateEnrolleReportEvent(aMetricId, lEventQuery);
}

function evaluateEnrolleReportEvent(aMetricId, aEventList) {
    "use strict";
    var lResult = 0,
        lIsConfirmed = true,
        lIsClosed = true,
        lDebugObject = {},
        lItem,
        lKey;

    for (lKey in aEventList) {
        if (aEventList.hasOwnProperty(lKey)) {
            lItem = aEventList[lKey];
            if (lIsConfirmed) {
                lIsConfirmed = lItem.IsConfirmed;
            }
            if (lIsClosed) {
                lIsClosed = !lItem.IsOpen;
            }
        }
    }

    if (lIsClosed && lIsConfirmed) {
        lResult = 0;
    } else if (lIsClosed && !lIsConfirmed) {
        lResult = 1;
    } else if (!lIsClosed && !lIsConfirmed) {
        lResult = 2;
    } else if (!lIsClosed && lIsConfirmed) {
        lResult = 3;
    }

    return lResult.toString();
}
